// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/assets/images/banner-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/assets/images/login_page.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pointer-events-none {
  pointer-events: none;
}
.pointer-events-auto {
  pointer-events: auto;
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.-bottom-0\\.5 {
  bottom: -0.125rem;
}
.-bottom-1 {
  bottom: -0.25rem;
}
.-right-0\\.5 {
  right: -0.125rem;
}
.-right-1 {
  right: -0.25rem;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-1 {
  bottom: 0.25rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.bottom-full {
  bottom: 100%;
}
.end-0 {
  inset-inline-end: 0px;
}
.left-0 {
  left: 0px;
}
.left-1 {
  left: 0.25rem;
}
.left-1\\/2 {
  left: 50%;
}
.left-3 {
  left: 0.75rem;
}
.left-4 {
  left: 1rem;
}
.left-\\[3px\\] {
  left: 3px;
}
.left-\\[8\\%\\] {
  left: 8%;
}
.right-0 {
  right: 0px;
}
.right-1 {
  right: 0.25rem;
}
.right-14 {
  right: 3.5rem;
}
.right-2 {
  right: 0.5rem;
}
.right-2\\.5 {
  right: 0.625rem;
}
.right-3 {
  right: 0.75rem;
}
.right-4 {
  right: 1rem;
}
.right-\\[8\\%\\] {
  right: 8%;
}
.top-0 {
  top: 0px;
}
.top-1 {
  top: 0.25rem;
}
.top-1\\.5 {
  top: 0.375rem;
}
.top-1\\/2 {
  top: 50%;
}
.top-14 {
  top: 3.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.top-4 {
  top: 1rem;
}
.top-8 {
  top: 2rem;
}
.top-\\[15\\%\\] {
  top: 15%;
}
.top-\\[18\\%\\] {
  top: 18%;
}
.top-\\[34px\\] {
  top: 34px;
}
.top-\\[36px\\] {
  top: 36px;
}
.top-\\[38px\\] {
  top: 38px;
}
.top-\\[calc\\(100\\%\\+6px\\)\\] {
  top: calc(100% + 6px);
}
.top-\\[calc\\(var\\(--pm-header-offset\\)\\+0\\.75rem\\)\\] {
  top: calc(var(--pm-header-offset) + 0.75rem);
}
.top-auto {
  top: auto;
}
.top-full {
  top: 100%;
}
.\\!z-\\[100000\\] {
  z-index: 100000 !important;
}
.\\!z-\\[1400\\] {
  z-index: 1400 !important;
}
.\\!z-\\[2005\\] {
  z-index: 2005 !important;
}
.\\!z-\\[2010\\] {
  z-index: 2010 !important;
}
.\\!z-\\[2100\\] {
  z-index: 2100 !important;
}
.\\!z-\\[99999\\] {
  z-index: 99999 !important;
}
.z-10 {
  z-index: 10;
}
.z-20 {
  z-index: 20;
}
.z-50 {
  z-index: 50;
}
.z-\\[1000\\] {
  z-index: 1000;
}
.z-\\[10050\\] {
  z-index: 10050;
}
.z-\\[1055\\] {
  z-index: 1055;
}
.z-\\[11\\] {
  z-index: 11;
}
.z-\\[1300\\] {
  z-index: 1300;
}
.z-\\[1400\\] {
  z-index: 1400;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[2000\\] {
  z-index: 2000;
}
.z-\\[21\\] {
  z-index: 21;
}
.z-\\[2\\] {
  z-index: 2;
}
.z-\\[900\\] {
  z-index: 900;
}
.order-1 {
  order: 1;
}
.order-2 {
  order: 2;
}
.order-3 {
  order: 3;
}
.col-span-12 {
  grid-column: span 12 / span 12;
}
.m-0 {
  margin: 0px;
}
.m-2 {
  margin: 0.5rem;
}
.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.mx-1\\.5 {
  margin-left: 0.375rem;
  margin-right: 0.375rem;
}
.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}
.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}
.my-1 {
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}
.my-12 {
  margin-top: 3rem;
  margin-bottom: 3rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
.my-\\[0\\.313rem\\] {
  margin-top: 0.313rem;
  margin-bottom: 0.313rem;
}
.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}
.\\!mt-2 {
  margin-top: 0.5rem !important;
}
.-mt-3 {
  margin-top: -0.75rem;
}
.mb-0 {
  margin-bottom: 0px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-1\\.5 {
  margin-bottom: 0.375rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-2\\.5 {
  margin-bottom: 0.625rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-3\\.5 {
  margin-bottom: 0.875rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-7 {
  margin-bottom: 1.75rem;
}
.mb-\\[0\\.5em\\] {
  margin-bottom: 0.5em;
}
.mb-\\[18px\\] {
  margin-bottom: 18px;
}
.mb-\\[7px\\] {
  margin-bottom: 7px;
}
.me-0 {
  margin-inline-end: 0px;
}
.me-1 {
  margin-inline-end: 0.25rem;
}
.me-2 {
  margin-inline-end: 0.5rem;
}
.me-3 {
  margin-inline-end: 0.75rem;
}
.me-4 {
  margin-inline-end: 1rem;
}
.ml-0 {
  margin-left: 0px;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[3px\\] {
  margin-left: 3px;
}
.ml-auto {
  margin-left: auto;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-1\\.5 {
  margin-right: 0.375rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-2\\.5 {
  margin-right: 0.625rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mr-5 {
  margin-right: 1.25rem;
}
.ms-1 {
  margin-inline-start: 0.25rem;
}
.ms-2 {
  margin-inline-start: 0.5rem;
}
.ms-3 {
  margin-inline-start: 0.75rem;
}
.ms-4 {
  margin-inline-start: 1rem;
}
.ms-auto {
  margin-inline-start: auto;
}
.mt-0 {
  margin-top: 0px;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-1\\.5 {
  margin-top: 0.375rem;
}
.mt-14 {
  margin-top: 3.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-2\\.5 {
  margin-top: 0.625rem;
}
.mt-24 {
  margin-top: 6rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-\\[1\\.2rem\\] {
  margin-top: 1.2rem;
}
.mt-\\[18px\\] {
  margin-top: 18px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-auto {
  margin-top: auto;
}
.mt-px {
  margin-top: 1px;
}
.box-border {
  box-sizing: border-box;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.\\!flex {
  display: flex !important;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.\\!h-3\\.5 {
  height: 0.875rem !important;
}
.\\!h-5 {
  height: 1.25rem !important;
}
.\\!h-6 {
  height: 1.5rem !important;
}
.h-0 {
  height: 0px;
}
.h-0\\.5 {
  height: 0.125rem;
}
.h-1 {
  height: 0.25rem;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-3\\.5 {
  height: 0.875rem;
}
.h-4 {
  height: 1rem;
}
.h-5 {
  height: 1.25rem;
}
.h-6 {
  height: 1.5rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[0\\.313rem\\] {
  height: 0.313rem;
}
.h-\\[1\\.375rem\\] {
  height: 1.375rem;
}
.h-\\[118px\\] {
  height: 118px;
}
.h-\\[18px\\] {
  height: 18px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[248px\\] {
  height: 248px;
}
.h-\\[26px\\] {
  height: 26px;
}
.h-\\[3\\.875rem\\] {
  height: 3.875rem;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-\\[34px\\] {
  height: 34px;
}
.h-\\[3px\\] {
  height: 3px;
}
.h-\\[44px\\] {
  height: 44px;
}
.h-\\[72px\\] {
  height: 72px;
}
.h-\\[76px\\] {
  height: 76px;
}
.h-\\[7px\\] {
  height: 7px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.\\!max-h-8 {
  max-height: 2rem !important;
}
.\\!max-h-\\[20px\\] {
  max-height: 20px !important;
}
.max-h-10 {
  max-height: 2.5rem;
}
.max-h-\\[calc\\(100dvh-120px\\)\\] {
  max-height: calc(100dvh - 120px);
}
.max-h-\\[min\\(92dvh\\2c 900px\\)\\] {
  max-height: min(92dvh, 900px);
}
.max-h-\\[var\\(--order-panel-max-h\\)\\] {
  max-height: var(--order-panel-max-h);
}
.\\!min-h-0 {
  min-height: 0px !important;
}
.\\!min-h-8 {
  min-height: 2rem !important;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-10 {
  min-height: 2.5rem;
}
.min-h-11 {
  min-height: 2.75rem;
}
.min-h-12 {
  min-height: 3rem;
}
.min-h-40 {
  min-height: 10rem;
}
.min-h-8 {
  min-height: 2rem;
}
.min-h-9 {
  min-height: 2.25rem;
}
.min-h-\\[112px\\] {
  min-height: 112px;
}
.min-h-\\[180px\\] {
  min-height: 180px;
}
.min-h-\\[21px\\] {
  min-height: 21px;
}
.min-h-\\[26px\\] {
  min-height: 26px;
}
.min-h-\\[34px\\] {
  min-height: 34px;
}
.min-h-\\[42px\\] {
  min-height: 42px;
}
.min-h-\\[460px\\] {
  min-height: 460px;
}
.min-h-\\[5\\.2em\\] {
  min-height: 5.2em;
}
.min-h-\\[55px\\] {
  min-height: 55px;
}
.min-h-\\[56px\\] {
  min-height: 56px;
}
.min-h-\\[84px\\] {
  min-height: 84px;
}
.min-h-\\[calc\\(100\\%-5rem\\)\\] {
  min-height: calc(100% - 5rem);
}
.min-h-\\[calc\\(100vh-160px\\)\\] {
  min-height: calc(100vh - 160px);
}
.min-h-\\[clamp\\(120px\\2c 28vw\\2c 220px\\)\\] {
  min-height: clamp(120px, 28vw, 220px);
}
.\\!w-3\\.5 {
  width: 0.875rem !important;
}
.\\!w-6 {
  width: 1.5rem !important;
}
.\\!w-auto {
  width: auto !important;
}
.w-1 {
  width: 0.25rem;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-1\\/2 {
  width: 50%;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-3 {
  width: 0.75rem;
}
.w-3\\.5 {
  width: 0.875rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[0\\.313rem\\] {
  width: 0.313rem;
}
.w-\\[1\\.375rem\\] {
  width: 1.375rem;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[140px\\] {
  width: 140px;
}
.w-\\[18px\\] {
  width: 18px;
}
.w-\\[22px\\] {
  width: 22px;
}
.w-\\[26px\\] {
  width: 26px;
}
.w-\\[29\\%\\] {
  width: 29%;
}
.w-\\[3\\.875rem\\] {
  width: 3.875rem;
}
.w-\\[30px\\] {
  width: 30px;
}
.w-\\[346px\\] {
  width: 346px;
}
.w-\\[34px\\] {
  width: 34px;
}
.w-\\[42\\%\\] {
  width: 42%;
}
.w-\\[58\\%\\] {
  width: 58%;
}
.w-\\[7px\\] {
  width: 7px;
}
.w-\\[800px\\] {
  width: 800px;
}
.w-\\[calc\\(100\\%-2rem\\)\\] {
  width: calc(100% - 2rem);
}
.w-\\[min\\(100\\%\\2c calc\\(100\\%-var\\(--pm-content-pad\\)\\*2\\)\\)\\] {
  width: min(100%, calc(100% - var(--pm-content-pad) * 2));
}
.w-\\[min\\(420px\\2c 100\\%\\)\\] {
  width: min(420px, 100%);
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-10 {
  min-width: 2.5rem;
}
.min-w-\\[110px\\] {
  min-width: 110px;
}
.min-w-\\[120px\\] {
  min-width: 120px;
}
.min-w-\\[140px\\] {
  min-width: 140px;
}
.min-w-\\[16\\.3125rem\\] {
  min-width: 16.3125rem;
}
.min-w-\\[160px\\] {
  min-width: 160px;
}
.min-w-\\[184px\\] {
  min-width: 184px;
}
.min-w-\\[240px\\] {
  min-width: 240px;
}
.min-w-\\[24px\\] {
  min-width: 24px;
}
.min-w-\\[34px\\] {
  min-width: 34px;
}
.min-w-\\[368px\\] {
  min-width: 368px;
}
.min-w-\\[36px\\] {
  min-width: 36px;
}
.min-w-\\[50px\\] {
  min-width: 50px;
}
.min-w-\\[5rem\\] {
  min-width: 5rem;
}
.min-w-full {
  min-width: 100%;
}
.\\!max-w-\\[22px\\] {
  max-width: 22px !important;
}
.\\!max-w-\\[400px\\] {
  max-width: 400px !important;
}
.\\!max-w-\\[440px\\] {
  max-width: 440px !important;
}
.\\!max-w-\\[468px\\] {
  max-width: 468px !important;
}
.\\!max-w-\\[480px\\] {
  max-width: 480px !important;
}
.\\!max-w-\\[500px\\] {
  max-width: 500px !important;
}
.\\!max-w-\\[540px\\] {
  max-width: 540px !important;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-6 {
  max-width: 1.5rem;
}
.max-w-\\[1100px\\] {
  max-width: 1100px;
}
.max-w-\\[1400px\\] {
  max-width: 1400px;
}
.max-w-\\[160px\\] {
  max-width: 160px;
}
.max-w-\\[18\\.75rem\\] {
  max-width: 18.75rem;
}
.max-w-\\[200px\\] {
  max-width: 200px;
}
.max-w-\\[220px\\] {
  max-width: 220px;
}
.max-w-\\[280px\\] {
  max-width: 280px;
}
.max-w-\\[3\\.875rem\\] {
  max-width: 3.875rem;
}
.max-w-\\[420px\\] {
  max-width: 420px;
}
.max-w-\\[442px\\] {
  max-width: 442px;
}
.max-w-\\[460px\\] {
  max-width: 460px;
}
.max-w-\\[760px\\] {
  max-width: 760px;
}
.max-w-\\[800px\\] {
  max-width: 800px;
}
.max-w-\\[80vw\\] {
  max-width: 80vw;
}
.max-w-full {
  max-width: 100%;
}
.max-w-none {
  max-width: none;
}
.flex-1 {
  flex: 1 1;
}
.flex-\\[0_0_auto\\] {
  flex: 0 0 auto;
}
.flex-\\[1_0_auto\\] {
  flex: 1 0 auto;
}
.flex-\\[1_1_140px\\] {
  flex: 1 1 140px;
}
.flex-auto {
  flex: 1 1 auto;
}
.shrink-0 {
  flex-shrink: 0;
}
.basis-\\[18\\.75rem\\] {
  flex-basis: 18.75rem;
}
.table-fixed {
  table-layout: fixed;
}
.border-collapse {
  border-collapse: collapse;
}
.origin-center {
  transform-origin: center;
}
.origin-top-left {
  transform-origin: top left;
}
.\\!-translate-y-\\[50px\\] {
  --tw-translate-y: -50px !important;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-y-1\\/2 {
  --tw-translate-y: 50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[-8deg\\] {
  --tw-rotate: -8deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-\\[8deg\\] {
  --tw-rotate: 8deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-95 {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.scale-\\[0\\.92\\] {
  --tw-scale-x: 0.92;
  --tw-scale-y: 0.92;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.\\!transform-none {
  transform: none !important;
}
.transform-none {
  transform: none;
}
@keyframes pm-fade-in-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-\\[pm-fade-in-up_0\\.24s_cubic-bezier\\(0\\.4\\2c 0\\2c 0\\.2\\2c 1\\)_0\\.18s_both\\] {
  animation: pm-fade-in-up 0.24s cubic-bezier(0.4,0,0.2,1) 0.18s both;
}
@keyframes how-it-works-slide-in {
  from {
    opacity: 0;
    transform: translateX(18px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.animate-how-it-works-slide-in {
  animation: how-it-works-slide-in 0.28s cubic-bezier(0.4, 0, 0.2, 1) both;
}
@keyframes molecule-graph-pulse {
  0% {
    transform: scale(1);
    opacity: 0.55;
  }
  70%, 100% {
    transform: scale(2.8);
    opacity: 0;
  }
}
.animate-molecule-graph-pulse {
  animation: molecule-graph-pulse 1.8s cubic-bezier(0.22, 0.61, 0.36, 1) infinite;
}
@keyframes molecule-spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-molecule-spin {
  animation: molecule-spin 0.8s linear infinite;
}
@keyframes news-desc-enter {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-news-desc-enter {
  animation: news-desc-enter 0.22s cubic-bezier(0.4, 0, 0.2, 1) both;
}
@keyframes news-item-enter {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-news-item-enter {
  animation: news-item-enter 0.4s cubic-bezier(0.4, 0, 0.2, 1) both;
}
@keyframes news-live-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.45;
    transform: scale(0.72);
  }
}
.animate-news-live-pulse {
  animation: news-live-pulse 1.6s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
@keyframes news-overlay-enter {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-news-overlay-enter {
  animation: news-overlay-enter 0.34s cubic-bezier(0.4, 0, 0.2, 1) both;
}
@keyframes news-highlight-sweep {
  0% {
    background-position: 120% 0;
  }
  100% {
    background-position: -120% 0;
  }
}
.animate-news-overlay-scan {
  animation: news-highlight-sweep 2.8s linear infinite;
}
@keyframes news-ticker-scroll {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-50%);
  }
}
.animate-news-ticker-scroll {
  animation: news-ticker-scroll 120s linear infinite;
}
@keyframes pm-fade-in-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-pm-content-in {
  animation: pm-fade-in-up 0.36s cubic-bezier(0.4, 0, 0.2, 1) 0.05s both;
}
@keyframes pm-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animate-pm-fade-in {
  animation: pm-fade-in 0.18s ease both;
}
@keyframes pm-fade-in-up {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.animate-pm-fade-in-up {
  animation: pm-fade-in-up 0.24s cubic-bezier(0.4, 0, 0.2, 1) both;
}
@keyframes pm-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.animate-pm-page-enter {
  animation: pm-fade-in 0.36s cubic-bezier(0.4, 0, 0.2, 1) both;
}
@keyframes pm-scale-in {
  from {
    opacity: 0;
    transform: scale(0.98);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
.animate-pm-scale-in {
  animation: pm-scale-in 0.28s ease both;
}
@keyframes pm-slide-down {
  from {
    opacity: 0;
    max-height: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    max-height: 1200px;
    transform: translateY(0);
  }
}
.animate-pm-slide-down {
  animation: pm-slide-down 0.24s cubic-bezier(0.4, 0, 0.2, 1) both;
}
@keyframes pulse {
  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-default {
  cursor: default;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.resize {
  resize: both;
}
.scroll-mt-24 {
  scroll-margin-top: 6rem;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.appearance-none {
  appearance: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}
.grid-cols-\\[1fr_auto\\] {
  grid-template-columns: 1fr auto;
}
.grid-cols-\\[200px_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 200px minmax(0,1fr);
}
.grid-cols-\\[220px_minmax\\(0\\2c 1fr\\)\\] {
  grid-template-columns: 220px minmax(0,1fr);
}
.grid-cols-\\[28px_minmax\\(0\\2c 1fr\\)_auto_auto\\] {
  grid-template-columns: 28px minmax(0,1fr) auto auto;
}
.grid-cols-\\[repeat\\(auto-fill\\2c minmax\\(240px\\2c 1fr\\)\\)\\] {
  grid-template-columns: repeat(auto-fill,minmax(240px,1fr));
}
.grid-rows-\\[0fr\\] {
  grid-template-rows: 0fr;
}
.grid-rows-\\[1fr\\] {
  grid-template-rows: 1fr;
}
.\\!flex-row {
  flex-direction: row !important;
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.\\!flex-wrap {
  flex-wrap: wrap !important;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.place-items-center {
  place-items: center;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.\\!items-center {
  align-items: center !important;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.items-stretch {
  align-items: stretch;
}
.\\!justify-start {
  justify-content: flex-start !important;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.\\!justify-center {
  justify-content: center !important;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.justify-items-center {
  justify-items: center;
}
.gap-0 {
  gap: 0px;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-2\\.5 {
  gap: 0.625rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-5 {
  gap: 1.25rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-\\[7px\\] {
  gap: 7px;
}
.gap-x-3 {
  column-gap: 0.75rem;
}
.gap-x-4 {
  column-gap: 1rem;
}
.gap-x-5 {
  column-gap: 1.25rem;
}
.gap-x-7 {
  column-gap: 1.75rem;
}
.gap-x-\\[30px\\] {
  column-gap: 30px;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.gap-y-3\\.5 {
  row-gap: 0.875rem;
}
.gap-y-\\[22px\\] {
  row-gap: 22px;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.self-center {
  align-self: center;
}
.overflow-auto {
  overflow: auto;
}
.\\!overflow-hidden {
  overflow: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-visible {
  overflow: visible;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.overflow-x-hidden {
  overflow-x: hidden;
}
.overflow-y-hidden {
  overflow-y: hidden;
}
.overscroll-contain {
  overscroll-behavior: contain;
}
.scroll-auto {
  scroll-behavior: auto;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.whitespace-normal {
  white-space: normal;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-line {
  white-space: pre-line;
}
.text-nowrap {
  text-wrap: nowrap;
}
.break-all {
  word-break: break-all;
}
.\\!rounded-lg {
  border-radius: 0.5rem !important;
}
.\\!rounded-xl {
  border-radius: 0.75rem !important;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-\\[0\\.313rem\\] {
  border-radius: 0.313rem;
}
.rounded-\\[0\\.625rem\\] {
  border-radius: 0.625rem;
}
.rounded-\\[0\\.875rem\\] {
  border-radius: 0.875rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[14px\\] {
  border-radius: 14px;
}
.rounded-\\[2px\\] {
  border-radius: 2px;
}
.rounded-\\[7px\\] {
  border-radius: 7px;
}
.rounded-\\[var\\(--pm-radius-sm\\2c 6px\\)\\] {
  border-radius: var(--pm-radius-sm,6px);
}
.rounded-\\[var\\(--pm-radius-sm\\2c _6px\\)\\] {
  border-radius: var(--pm-radius-sm, 6px);
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.rounded-b-\\[15px\\] {
  border-bottom-right-radius: 15px;
  border-bottom-left-radius: 15px;
}
.rounded-b-none {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.rounded-r-\\[15px\\] {
  border-top-right-radius: 15px;
  border-bottom-right-radius: 15px;
}
.rounded-r-\\[6px\\] {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.rounded-t-\\[0\\.875rem\\] {
  border-top-left-radius: 0.875rem;
  border-top-right-radius: 0.875rem;
}
.rounded-t-\\[10px\\] {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.rounded-t-lg {
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
}
.rounded-t-xl {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-0 {
  border-width: 0px;
}
.border-2 {
  border-width: 2px;
}
.border-\\[0\\.25em\\] {
  border-width: 0.25em;
}
.border-\\[1\\.5px\\] {
  border-width: 1.5px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[3px\\] {
  border-width: 3px;
}
.border-\\[6px\\] {
  border-width: 6px;
}
.border-y {
  border-top-width: 1px;
  border-bottom-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-0 {
  border-bottom-width: 0px;
}
.border-r {
  border-right-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-solid {
  border-style: solid;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.\\!border-\\[\\#1cff17\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(28 255 23 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[\\#ff4d4d\\] {
  --tw-border-opacity: 1 !important;
  border-color: rgb(255 77 77 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.55\\)\\] {
  border-color: rgb(var(--pm-gold)/0.55) !important;
}
.\\!border-\\[var\\(--c\\)\\] {
  border-color: var(--c) !important;
}
.\\!border-\\[var\\(--red\\)\\] {
  border-color: var(--red) !important;
}
.\\!border-red-500 {
  --tw-border-opacity: 1 !important;
  border-color: rgb(239 68 68 / var(--tw-border-opacity, 1)) !important;
}
.\\!border-transparent {
  border-color: transparent !important;
}
.border-\\[\\#1cff17\\] {
  --tw-border-opacity: 1;
  border-color: rgb(28 255 23 / var(--tw-border-opacity, 1));
}
.border-\\[\\#5E5E5E\\] {
  --tw-border-opacity: 1;
  border-color: rgb(94 94 94 / var(--tw-border-opacity, 1));
}
.border-\\[\\#FFFFFF4D\\] {
  border-color: #FFFFFF4D;
}
.border-\\[\\#cb7d00\\] {
  --tw-border-opacity: 1;
  border-color: rgb(203 125 0 / var(--tw-border-opacity, 1));
}
.border-\\[\\#f7b731\\] {
  --tw-border-opacity: 1;
  border-color: rgb(247 183 49 / var(--tw-border-opacity, 1));
}
.border-\\[\\#ffffff33\\] {
  border-color: #ffffff33;
}
.border-\\[rgb\\(var\\(--color-line\\)\\/0\\.7\\)\\] {
  border-color: rgb(var(--color-line)/0.7);
}
.border-\\[rgb\\(var\\(--color-line\\)\\/0\\.8\\)\\] {
  border-color: rgb(var(--color-line)/0.8);
}
.border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.35\\)\\] {
  border-color: rgb(var(--pm-gold)/0.35);
}
.border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.4\\)\\] {
  border-color: rgb(var(--pm-gold)/0.4);
}
.border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.45\\)\\] {
  border-color: rgb(var(--pm-gold)/0.45);
}
.border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.5\\)\\] {
  border-color: rgb(var(--pm-gold)/0.5);
}
.border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.55\\)\\] {
  border-color: rgb(var(--pm-gold)/0.55);
}
.border-\\[var\\(--black\\)\\] {
  border-color: var(--black);
}
.border-\\[var\\(--darkGray\\)\\] {
  border-color: var(--darkGray);
}
.border-\\[var\\(--gray-60\\)\\] {
  border-color: var(--gray-60);
}
.border-\\[var\\(--gray-80\\)\\] {
  border-color: var(--gray-80);
}
.border-\\[var\\(--gray-90\\)\\] {
  border-color: var(--gray-90);
}
.border-\\[var\\(--red\\)\\] {
  border-color: var(--red);
}
.border-current {
  border-color: currentColor;
}
.border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity, 1));
}
.border-danger-soft {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger-soft) / var(--tw-border-opacity, 1));
}
.border-gold-dark {
  --tw-border-opacity: 1;
  border-color: rgb(203 125 0 / var(--tw-border-opacity, 1));
}
.border-gray-600 {
  --tw-border-opacity: 1;
  border-color: rgb(75 85 99 / var(--tw-border-opacity, 1));
}
.border-gray-700 {
  --tw-border-opacity: 1;
  border-color: rgb(55 65 81 / var(--tw-border-opacity, 1));
}
.border-info {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-info) / var(--tw-border-opacity, 1));
}
.border-ink {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-ink) / var(--tw-border-opacity, 1));
}
.border-line {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-line) / var(--tw-border-opacity, 1));
}
.border-line-card {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-border-card) / var(--tw-border-opacity, 1));
}
.border-line-strong {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-line-strong) / var(--tw-border-opacity, 1));
}
.border-line\\/70 {
  border-color: rgb(var(--color-line) / 0.7);
}
.border-line\\/75 {
  border-color: rgb(var(--color-line) / 0.75);
}
.border-line\\/85 {
  border-color: rgb(var(--color-line) / 0.85);
}
.border-line\\/90 {
  border-color: rgb(var(--color-line) / 0.9);
}
.border-surface-muted {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-surface-muted) / var(--tw-border-opacity, 1));
}
.border-surface-overlay {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-surface-overlay) / var(--tw-border-opacity, 1));
}
.border-transparent {
  border-color: transparent;
}
.border-warning-soft {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning-soft) / var(--tw-border-opacity, 1));
}
.border-warning\\/35 {
  border-color: rgb(var(--color-warning) / 0.35);
}
.border-white\\/20 {
  border-color: rgb(255 255 255 / 0.2);
}
.border-r-transparent {
  border-right-color: transparent;
}
.border-t-info {
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--color-info) / var(--tw-border-opacity, 1));
}
.\\!bg-\\[\\#1e1e1e\\] {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-\\[rgb\\(126_250_123\\/16\\%\\)\\] {
  background-color: rgb(126 250 123/16%) !important;
}
.\\!bg-\\[rgb\\(126_250_123\\/8\\%\\)\\] {
  background-color: rgb(126 250 123/8%) !important;
}
.\\!bg-\\[rgb\\(255_0_0\\/16\\%\\)\\] {
  background-color: rgb(255 0 0/16%) !important;
}
.\\!bg-\\[rgb\\(var\\(--pm-felt\\)\\/0\\.35\\)\\] {
  background-color: rgb(var(--pm-felt)/0.35) !important;
}
.\\!bg-\\[var\\(--gray-80\\)\\] {
  background-color: var(--gray-80) !important;
}
.\\!bg-danger-soft {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-danger-soft) / var(--tw-bg-opacity, 1)) !important;
}
.\\!bg-white {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1)) !important;
}
.bg-\\[\\#191d24\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(25 29 36 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1cff17\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(28 255 23 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#1e1e1e\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 30 30 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#262c36\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(38 44 54 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2a2d32\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(42 45 50 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#2b313d\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(43 49 61 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#54B8FF26\\] {
  background-color: #54B8FF26;
}
.bg-\\[\\#72F23826\\] {
  background-color: #72F23826;
}
.bg-\\[\\#FF494933\\] {
  background-color: #FF494933;
}
.bg-\\[\\#ef4444\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#ffffff05\\] {
  background-color: #ffffff05;
}
.bg-\\[rgb\\(126_250_123\\/16\\%\\)\\] {
  background-color: rgb(126 250 123/16%);
}
.bg-\\[rgb\\(28_255_23\\/0\\.22\\)\\] {
  background-color: rgb(28 255 23/0.22);
}
.bg-\\[rgb\\(var\\(--color-danger\\)\\/0\\.28\\)\\] {
  background-color: rgb(var(--color-danger)/0.28);
}
.bg-\\[rgb\\(var\\(--color-shadow\\)\\/0\\.45\\)\\] {
  background-color: rgb(var(--color-shadow)/0.45);
}
.bg-\\[rgb\\(var\\(--color-shadow\\)\\/0\\.55\\)\\] {
  background-color: rgb(var(--color-shadow)/0.55);
}
.bg-\\[rgb\\(var\\(--color-surface-raised\\)\\)\\] {
  background-color: rgb(var(--color-surface-raised));
}
.bg-\\[rgb\\(var\\(--pm-felt\\)\\/0\\.28\\)\\] {
  background-color: rgb(var(--pm-felt)/0.28);
}
.bg-\\[rgb\\(var\\(--pm-felt\\)\\/0\\.35\\)\\] {
  background-color: rgb(var(--pm-felt)/0.35);
}
.bg-\\[rgb\\(var\\(--pm-gold\\)\\)\\] {
  background-color: rgb(var(--pm-gold));
}
.bg-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.1\\)\\] {
  background-color: rgb(var(--pm-gold)/0.1);
}
.bg-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.12\\)\\] {
  background-color: rgb(var(--pm-gold)/0.12);
}
.bg-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.14\\)\\] {
  background-color: rgb(var(--pm-gold)/0.14);
}
.bg-\\[rgba\\(255\\2c 176\\2c 24\\2c 0\\.15\\)\\] {
  background-color: rgba(255,176,24,0.15);
}
.bg-\\[var\\(--blue-300\\)\\] {
  background-color: var(--blue-300);
}
.bg-\\[var\\(--darkGray\\)\\] {
  background-color: var(--darkGray);
}
.bg-\\[var\\(--gray-40\\)\\] {
  background-color: var(--gray-40);
}
.bg-\\[var\\(--gray-60\\)\\] {
  background-color: var(--gray-60);
}
.bg-\\[var\\(--gray-80\\)\\] {
  background-color: var(--gray-80);
}
.bg-\\[var\\(--gray-80-50\\)\\] {
  background-color: var(--gray-80-50);
}
.bg-\\[var\\(--gray-85\\)\\] {
  background-color: var(--gray-85);
}
.bg-\\[var\\(--gray-90\\)\\] {
  background-color: var(--gray-90);
}
.bg-accent-soft {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-accent-soft) / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/50 {
  background-color: rgb(0 0 0 / 0.5);
}
.bg-current {
  background-color: currentColor;
}
.bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity, 1));
}
.bg-danger-soft {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger-soft) / var(--tw-bg-opacity, 1));
}
.bg-gold-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(203 125 0 / var(--tw-bg-opacity, 1));
}
.bg-info {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-info) / var(--tw-bg-opacity, 1));
}
.bg-info\\/15 {
  background-color: rgb(var(--color-info) / 0.15);
}
.bg-ink {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-ink) / var(--tw-bg-opacity, 1));
}
.bg-line {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-line) / var(--tw-bg-opacity, 1));
}
.bg-line-strong {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-line-strong) / var(--tw-bg-opacity, 1));
}
.bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity, 1));
}
.bg-surface-muted {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-muted) / var(--tw-bg-opacity, 1));
}
.bg-surface-muted\\/85 {
  background-color: rgb(var(--color-surface-muted) / 0.85);
}
.bg-surface-muted\\/95 {
  background-color: rgb(var(--color-surface-muted) / 0.95);
}
.bg-surface-overlay {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-overlay) / var(--tw-bg-opacity, 1));
}
.bg-surface-overlay\\/55 {
  background-color: rgb(var(--color-surface-overlay) / 0.55);
}
.bg-surface-raised {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-raised) / var(--tw-bg-opacity, 1));
}
.bg-surface-raised\\/95 {
  background-color: rgb(var(--color-surface-raised) / 0.95);
}
.bg-transparent {
  background-color: transparent;
}
.bg-warning-soft {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning-soft) / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.\\!bg-none {
  background-image: none !important;
}
.bg-\\[linear-gradient\\(\\#EFD43C\\2c \\#CB7D00\\)\\] {
  background-image: linear-gradient(#EFD43C,#CB7D00);
}
.bg-\\[linear-gradient\\(180deg\\2c rgb\\(var\\(--color-surface\\)\\/0\\.9\\)_0\\%\\2c rgb\\(var\\(--color-surface\\)\\/0\\.9\\)_42\\%\\2c rgb\\(var\\(--color-surface\\)\\/0\\.66\\)_100\\%\\)\\] {
  background-image: linear-gradient(180deg,rgb(var(--color-surface)/0.9) 0%,rgb(var(--color-surface)/0.9) 42%,rgb(var(--color-surface)/0.66) 100%);
}
.bg-\\[linear-gradient\\(270deg\\2c \\#1e1e1e_0\\%\\2c rgba\\(15\\2c 25\\2c 35\\2c 0\\)_100\\%\\)\\] {
  background-image: linear-gradient(270deg,#1e1e1e 0%,rgba(15,25,35,0) 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c rgb\\(var\\(--color-surface-raised\\)\\)_0\\%\\2c rgb\\(var\\(--color-surface-muted\\)\\)_50\\%\\2c rgb\\(var\\(--color-surface-raised\\)\\)_100\\%\\)\\] {
  background-image: linear-gradient(90deg,rgb(var(--color-surface-raised)) 0%,rgb(var(--color-surface-muted)) 50%,rgb(var(--color-surface-raised)) 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c rgb\\(var\\(--pm-gold\\)\\/0\\.12\\)_0\\%\\2c rgb\\(var\\(--color-surface-raised\\)\\/0\\.95\\)_16\\%\\2c rgb\\(var\\(--color-surface-raised\\)\\/0\\.9\\)_100\\%\\)\\] {
  background-image: linear-gradient(90deg,rgb(var(--pm-gold)/0.12) 0%,rgb(var(--color-surface-raised)/0.95) 16%,rgb(var(--color-surface-raised)/0.9) 100%);
}
.bg-\\[linear-gradient\\(90deg\\2c transparent_0\\%\\2c rgb\\(var\\(--color-danger\\)\\/0\\.15\\)_20\\%\\2c rgb\\(var\\(--color-danger\\)\\)_50\\%\\2c rgb\\(var\\(--color-danger\\)\\/0\\.15\\)_80\\%\\2c transparent_100\\%\\)\\] {
  background-image: linear-gradient(90deg,transparent 0%,rgb(var(--color-danger)/0.15) 20%,rgb(var(--color-danger)) 50%,rgb(var(--color-danger)/0.15) 80%,transparent 100%);
}
.bg-\\[radial-gradient\\(120\\%_110\\%_at_100\\%_50\\%\\2c rgb\\(var\\(--pm-gold\\)\\/0\\.1\\)\\2c transparent_65\\%\\)\\] {
  background-image: radial-gradient(120% 110% at 100% 50%,rgb(var(--pm-gold)/0.1),transparent 65%);
}
.bg-\\[radial-gradient\\(120\\%_110\\%_at_100\\%_50\\%\\2c rgb\\(var\\(--pm-gold\\)\\/0\\.18\\)\\2c transparent_65\\%\\)\\] {
  background-image: radial-gradient(120% 110% at 100% 50%,rgb(var(--pm-gold)/0.18),transparent 65%);
}
.bg-\\[radial-gradient\\(circle_at_50\\%_20\\%\\2c rgb\\(var\\(--color-info-soft\\)\\/0\\.55\\)\\2c transparent_55\\%\\)\\2c linear-gradient\\(180deg\\2c rgb\\(var\\(--color-surface-muted\\)\\)_0\\%\\2c rgb\\(var\\(--color-surface-raised\\)\\)_100\\%\\)\\] {
  background-image: radial-gradient(circle at 50% 20%,rgb(var(--color-info-soft)/0.55),transparent 55%),linear-gradient(180deg,rgb(var(--color-surface-muted)) 0%,rgb(var(--color-surface-raised)) 100%);
}
.bg-gold-btn {
  background-image: linear-gradient(#EFD43C, #CB7D00);
}
.bg-gold-btn-180 {
  background-image: linear-gradient(180deg, #EFD43C 0%, #CB7D00 100%);
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}
.bg-login-banner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.bg-login-page {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.bg-pm-page {
  background-image: radial-gradient(120% 80% at 50% -20%, rgb(var(--pm-gold) / 0.16), transparent 55%), rgb(var(--color-surface));
}
.from-surface-overlay {
  --tw-gradient-from: rgb(var(--color-surface-overlay) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-surface-overlay) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-surface-raised {
  --tw-gradient-from: rgb(var(--color-surface-raised) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--color-surface-raised) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-transparent {
  --tw-gradient-from: transparent var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(0 0 0 / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-surface-muted {
  --tw-gradient-to: rgb(var(--color-surface-muted) / 1) var(--tw-gradient-to-position);
}
.to-surface-muted\\/50 {
  --tw-gradient-to: rgb(var(--color-surface-muted) / 0.5) var(--tw-gradient-to-position);
}
.to-surface-muted\\/70 {
  --tw-gradient-to: rgb(var(--color-surface-muted) / 0.7) var(--tw-gradient-to-position);
}
.to-surface-raised {
  --tw-gradient-to: rgb(var(--color-surface-raised) / 1) var(--tw-gradient-to-position);
}
.bg-\\[length\\:180\\%_100\\%\\] {
  background-size: 180% 100%;
}
.bg-\\[length\\:200\\%_100\\%\\] {
  background-size: 200% 100%;
}
.bg-contain {
  background-size: contain;
}
.bg-cover {
  background-size: cover;
}
.bg-bottom {
  background-position: bottom;
}
.bg-center {
  background-position: center;
}
.bg-top {
  background-position: top;
}
.bg-no-repeat {
  background-repeat: no-repeat;
}
.stroke-gold {
  stroke: #EFD43C;
}
.stroke-line {
  stroke: rgb(var(--color-line) / 1);
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.object-center {
  object-position: center;
}
.\\!p-0 {
  padding: 0px !important;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-2\\.5 {
  padding: 0.625rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-3\\.5 {
  padding: 0.875rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-\\[1\\.125rem\\] {
  padding: 1.125rem;
}
.p-\\[1\\.2rem\\] {
  padding: 1.2rem;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!px-3\\.5 {
  padding-left: 0.875rem !important;
  padding-right: 0.875rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.\\!py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-3\\.5 {
  padding-left: 0.875rem;
  padding-right: 0.875rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-\\[1\\.625rem\\] {
  padding-left: 1.625rem;
  padding-right: 1.625rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-3\\.5 {
  padding-top: 0.875rem;
  padding-bottom: 0.875rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.py-\\[0\\.438rem\\] {
  padding-top: 0.438rem;
  padding-bottom: 0.438rem;
}
.py-\\[0\\.9375rem\\] {
  padding-top: 0.9375rem;
  padding-bottom: 0.9375rem;
}
.py-\\[1\\.875rem\\] {
  padding-top: 1.875rem;
  padding-bottom: 1.875rem;
}
.py-\\[13px\\] {
  padding-top: 13px;
  padding-bottom: 13px;
}
.py-\\[22px\\] {
  padding-top: 22px;
  padding-bottom: 22px;
}
.py-\\[3px\\] {
  padding-top: 3px;
  padding-bottom: 3px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[7px\\] {
  padding-top: 7px;
  padding-bottom: 7px;
}
.py-\\[9px\\] {
  padding-top: 9px;
  padding-bottom: 9px;
}
.pb-0 {
  padding-bottom: 0px;
}
.pb-0\\.5 {
  padding-bottom: 0.125rem;
}
.pb-1 {
  padding-bottom: 0.25rem;
}
.pb-1\\.5 {
  padding-bottom: 0.375rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pb-3 {
  padding-bottom: 0.75rem;
}
.pb-3\\.5 {
  padding-bottom: 0.875rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-5 {
  padding-bottom: 1.25rem;
}
.pb-6 {
  padding-bottom: 1.5rem;
}
.pb-8 {
  padding-bottom: 2rem;
}
.pb-9 {
  padding-bottom: 2.25rem;
}
.pb-\\[18px\\] {
  padding-bottom: 18px;
}
.pl-0 {
  padding-left: 0px;
}
.pl-1\\.5 {
  padding-left: 0.375rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-12 {
  padding-left: 3rem;
}
.pl-3\\.5 {
  padding-left: 0.875rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pl-9 {
  padding-left: 2.25rem;
}
.pl-\\[18px\\] {
  padding-left: 18px;
}
.pl-\\[7\\.5rem\\] {
  padding-left: 7.5rem;
}
.pr-10 {
  padding-right: 2.5rem;
}
.pr-14 {
  padding-right: 3.5rem;
}
.pr-2 {
  padding-right: 0.5rem;
}
.pr-2\\.5 {
  padding-right: 0.625rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-3\\.5 {
  padding-right: 0.875rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pr-7 {
  padding-right: 1.75rem;
}
.pr-8 {
  padding-right: 2rem;
}
.pr-\\[13px\\] {
  padding-right: 13px;
}
.pr-\\[5\\.5rem\\] {
  padding-right: 5.5rem;
}
.pr-\\[6\\.875rem\\] {
  padding-right: 6.875rem;
}
.ps-4 {
  padding-inline-start: 1rem;
}
.pt-0 {
  padding-top: 0px;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-1\\.5 {
  padding-top: 0.375rem;
}
.pt-2 {
  padding-top: 0.5rem;
}
.pt-2\\.5 {
  padding-top: 0.625rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-3\\.5 {
  padding-top: 0.875rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-5 {
  padding-top: 1.25rem;
}
.pt-7 {
  padding-top: 1.75rem;
}
.pt-\\[0\\.3125rem\\] {
  padding-top: 0.3125rem;
}
.pt-\\[18px\\] {
  padding-top: 18px;
}
.pt-\\[22px\\] {
  padding-top: 22px;
}
.pt-\\[var\\(--pm-header-offset\\)\\] {
  padding-top: var(--pm-header-offset);
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.text-start {
  text-align: start;
}
.align-middle {
  vertical-align: middle;
}
.align-bottom {
  vertical-align: bottom;
}
.align-\\[-0\\.125em\\] {
  vertical-align: -0.125em;
}
.font-\\[inherit\\] {
  font-family: inherit;
}
.\\!text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-\\[0\\.813rem\\] {
  font-size: 0.813rem;
}
.text-\\[0\\.865rem\\] {
  font-size: 0.865rem;
}
.text-\\[0\\.875rem\\] {
  font-size: 0.875rem;
}
.text-\\[0\\.95rem\\] {
  font-size: 0.95rem;
}
.text-\\[1\\.05rem\\] {
  font-size: 1.05rem;
}
.text-\\[1\\.35rem\\] {
  font-size: 1.35rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-\\[12\\.5px\\] {
  font-size: 12.5px;
}
.text-\\[12px\\] {
  font-size: 12px;
}
.text-\\[13\\.5px\\] {
  font-size: 13.5px;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[14\\.5px\\] {
  font-size: 14.5px;
}
.text-\\[14px\\] {
  font-size: 14px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[9px\\] {
  font-size: 9px;
}
.text-\\[clamp\\(1\\.35rem\\2c 2\\.4vw\\2c 1\\.75rem\\)\\] {
  font-size: clamp(1.35rem, 2.4vw, 1.75rem);
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-\\[550\\] {
  font-weight: 550;
}
.font-\\[750\\] {
  font-weight: 750;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.normal-case {
  text-transform: none;
}
.not-italic {
  font-style: normal;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.\\!leading-normal {
  line-height: 1.5 !important;
}
.leading-4 {
  line-height: 1rem;
}
.leading-5 {
  line-height: 1.25rem;
}
.leading-6 {
  line-height: 1.5rem;
}
.leading-7 {
  line-height: 1.75rem;
}
.leading-\\[1\\.125rem\\] {
  line-height: 1.125rem;
}
.leading-\\[1\\.15\\] {
  line-height: 1.15;
}
.leading-\\[1\\.1\\] {
  line-height: 1.1;
}
.leading-\\[1\\.25\\] {
  line-height: 1.25;
}
.leading-\\[1\\.2\\] {
  line-height: 1.2;
}
.leading-\\[1\\.35\\] {
  line-height: 1.35;
}
.leading-\\[1\\.3\\] {
  line-height: 1.3;
}
.leading-\\[1\\.45\\] {
  line-height: 1.45;
}
.leading-\\[1\\.4\\] {
  line-height: 1.4;
}
.leading-\\[1\\.55\\] {
  line-height: 1.55;
}
.leading-\\[1\\.5\\] {
  line-height: 1.5;
}
.leading-\\[1\\.65\\] {
  line-height: 1.65;
}
.leading-\\[1\\.688rem\\] {
  line-height: 1.688rem;
}
.leading-\\[1\\.6\\] {
  line-height: 1.6;
}
.leading-\\[14px\\] {
  line-height: 14px;
}
.leading-\\[18px\\] {
  line-height: 18px;
}
.leading-\\[28\\.12px\\] {
  line-height: 28.12px;
}
.leading-none {
  line-height: 1;
}
.leading-normal {
  line-height: 1.5;
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[-0\\.015em\\] {
  letter-spacing: -0.015em;
}
.tracking-\\[-0\\.01em\\] {
  letter-spacing: -0.01em;
}
.tracking-\\[-0\\.02em\\] {
  letter-spacing: -0.02em;
}
.tracking-\\[-0\\.03em\\] {
  letter-spacing: -0.03em;
}
.tracking-\\[0\\.01em\\] {
  letter-spacing: 0.01em;
}
.tracking-\\[0\\.02em\\] {
  letter-spacing: 0.02em;
}
.tracking-\\[0\\.03em\\] {
  letter-spacing: 0.03em;
}
.tracking-\\[0\\.04em\\] {
  letter-spacing: 0.04em;
}
.tracking-\\[0\\.08em\\] {
  letter-spacing: 0.08em;
}
.tracking-\\[0\\.12em\\] {
  letter-spacing: 0.12em;
}
.tracking-\\[0\\.1em\\] {
  letter-spacing: 0.1em;
}
.tracking-\\[0\\.4em\\] {
  letter-spacing: 0.4em;
}
.tracking-normal {
  letter-spacing: 0em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.\\!text-\\[rgb\\(var\\(--pm-gold\\)\\)\\] {
  color: rgb(var(--pm-gold)) !important;
}
.\\!text-danger-contrast {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-danger-contrast) / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.\\!text-white\\/80 {
  color: rgb(255 255 255 / 0.8) !important;
}
.text-\\[\\#3DDB8C\\] {
  --tw-text-opacity: 1;
  color: rgb(61 219 140 / var(--tw-text-opacity, 1));
}
.text-\\[\\#54B8FF\\] {
  --tw-text-opacity: 1;
  color: rgb(84 184 255 / var(--tw-text-opacity, 1));
}
.text-\\[\\#5E5E5E\\] {
  --tw-text-opacity: 1;
  color: rgb(94 94 94 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF4949\\] {
  --tw-text-opacity: 1;
  color: rgb(255 73 73 / var(--tw-text-opacity, 1));
}
.text-\\[\\#FF8A00\\] {
  --tw-text-opacity: 1;
  color: rgb(255 138 0 / var(--tw-text-opacity, 1));
}
.text-\\[\\#ef5350\\] {
  --tw-text-opacity: 1;
  color: rgb(239 83 80 / var(--tw-text-opacity, 1));
}
.text-\\[\\#f5e642\\] {
  --tw-text-opacity: 1;
  color: rgb(245 230 66 / var(--tw-text-opacity, 1));
}
.text-\\[rgb\\(239_212_60_\\/_var\\(--tw-text-opacity\\2c 1\\)\\)\\] {
  color: rgb(239 212 60 / var(--tw-text-opacity,1));
}
.text-\\[rgb\\(var\\(--pm-gold\\)\\)\\] {
  color: rgb(var(--pm-gold));
}
.text-\\[rgba\\(255\\2c 176\\2c 24\\2c 1\\)\\] {
  color: rgba(255,176,24,1);
}
.text-\\[var\\(--blue-300\\)\\] {
  color: var(--blue-300);
}
.text-\\[var\\(--gray-20\\)\\] {
  color: var(--gray-20);
}
.text-\\[var\\(--gray-40\\)\\] {
  color: var(--gray-40);
}
.text-\\[var\\(--live-green\\)\\] {
  color: var(--live-green);
}
.text-\\[var\\(--red\\)\\] {
  color: var(--red);
}
.text-\\[var\\(--white\\)\\] {
  color: var(--white);
}
.text-accent-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--color-accent-contrast) / var(--tw-text-opacity, 1));
}
.text-amber-400 {
  --tw-text-opacity: 1;
  color: rgb(251 191 36 / var(--tw-text-opacity, 1));
}
.text-danger {
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger) / var(--tw-text-opacity, 1));
}
.text-danger-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger-contrast) / var(--tw-text-opacity, 1));
}
.text-gold {
  --tw-text-opacity: 1;
  color: rgb(239 212 60 / var(--tw-text-opacity, 1));
}
.text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(156 163 175 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-info {
  --tw-text-opacity: 1;
  color: rgb(var(--color-info) / var(--tw-text-opacity, 1));
}
.text-inherit {
  color: inherit;
}
.text-ink {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink) / var(--tw-text-opacity, 1));
}
.text-ink-faint {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink-faint) / var(--tw-text-opacity, 1));
}
.text-ink-inverse {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink-inverse) / var(--tw-text-opacity, 1));
}
.text-ink-muted {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink-muted) / var(--tw-text-opacity, 1));
}
.text-ink-soft {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink-soft) / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-success {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success) / var(--tw-text-opacity, 1));
}
.text-success-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success-contrast) / var(--tw-text-opacity, 1));
}
.text-surface-overlay {
  --tw-text-opacity: 1;
  color: rgb(var(--color-surface-overlay) / var(--tw-text-opacity, 1));
}
.text-surface-raised {
  --tw-text-opacity: 1;
  color: rgb(var(--color-surface-raised) / var(--tw-text-opacity, 1));
}
.text-warning {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning) / var(--tw-text-opacity, 1));
}
.text-warning-contrast {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-contrast) / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-white\\/50 {
  color: rgb(255 255 255 / 0.5);
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.underline-offset-2 {
  text-underline-offset: 2px;
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-25 {
  opacity: 0.25;
}
.opacity-55 {
  opacity: 0.55;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-70 {
  opacity: 0.7;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-85 {
  opacity: 0.85;
}
.opacity-90 {
  opacity: 0.9;
}
.opacity-\\[0\\.88\\] {
  opacity: 0.88;
}
.\\!shadow-none {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-\\[0_-10px_32px_rgb\\(var\\(--color-shadow\\)\\/0\\.22\\)\\] {
  --tw-shadow: 0 -10px 32px rgb(var(--color-shadow)/0.22);
  --tw-shadow-colored: 0 -10px 32px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_\\#1cff17\\2c 0_0_10px_rgb\\(28_255_23\\/35\\%\\)\\] {
  --tw-shadow: 0 0 0 1px #1cff17,0 0 10px rgb(28 255 23/35%);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color), 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_\\#ff4d4d\\2c 0_0_10px_rgb\\(255_0_0\\/35\\%\\)\\] {
  --tw-shadow: 0 0 0 1px #ff4d4d,0 0 10px rgb(255 0 0/35%);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color), 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_rgb\\(var\\(--color-danger\\)\\/0\\.35\\)\\] {
  --tw-shadow: 0 0 0 1px rgb(var(--color-danger)/0.35);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_0_1px_rgb\\(var\\(--pm-gold\\)\\/0\\.35\\)\\] {
  --tw-shadow: 0 0 0 1px rgb(var(--pm-gold)/0.35);
  --tw-shadow-colored: 0 0 0 1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_1\\.25rem_0_var\\(--darkGray-40\\)\\2c 0_0\\.5rem_1rem_0_var\\(--darkGray-40\\)\\] {
  --tw-shadow: 0 0 1.25rem 0 var(--darkGray-40),0 0.5rem 1rem 0 var(--darkGray-40);
  --tw-shadow-colored: 0 0 1.25rem 0 var(--tw-shadow-color), 0 0.5rem 1rem 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_0_10px_rgb\\(var\\(--color-danger\\)\\/0\\.45\\)\\] {
  --tw-shadow: 0 0 10px rgb(var(--color-danger)/0.45);
  --tw-shadow-colored: 0 0 10px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)\\] {
  --tw-shadow: 0 10px 40px rgba(0,0,0,0.18);
  --tw-shadow-colored: 0 10px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_10px_40px_rgba\\(0\\2c 0\\2c 0\\2c 0\\.55\\)\\] {
  --tw-shadow: 0 10px 40px rgba(0,0,0,0.55);
  --tw-shadow-colored: 0 10px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_1px_2px_rgb\\(var\\(--color-shadow\\)\\/0\\.04\\)\\] {
  --tw-shadow: 0 1px 2px rgb(var(--color-shadow)/0.04);
  --tw-shadow-colored: 0 1px 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_24px_60px_rgb\\(var\\(--color-shadow\\)\\/0\\.28\\)\\] {
  --tw-shadow: 0 24px 60px rgb(var(--color-shadow)/0.28);
  --tw-shadow-colored: 0 24px 60px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgb\\(var\\(--color-shadow\\)\\/0\\.08\\)\\] {
  --tw-shadow: 0 8px 20px rgb(var(--color-shadow)/0.08);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[0_8px_20px_rgb\\(var\\(--color-shadow\\)\\/0\\.28\\)\\] {
  --tw-shadow: 0 8px 20px rgb(var(--color-shadow)/0.28);
  --tw-shadow-colored: 0 8px 20px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgb\\(255_255_255\\/0\\.03\\)\\] {
  --tw-shadow: inset 0 1px 0 rgb(255 255 255/0.03);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgb\\(var\\(--pm-gold\\)\\/0\\.06\\)\\2c 0_18px_40px_rgb\\(var\\(--color-shadow\\)\\/0\\.18\\)\\] {
  --tw-shadow: inset 0 1px 0 rgb(var(--pm-gold)/0.06),0 18px 40px rgb(var(--color-shadow)/0.18);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 18px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgb\\(var\\(--pm-gold\\)\\/0\\.06\\)\\] {
  --tw-shadow: inset 0 1px 0 rgb(var(--pm-gold)/0.06);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[inset_0_1px_0_rgb\\(var\\(--pm-gold\\)\\/0\\.08\\)\\2c 0_8px_22px_rgb\\(var\\(--color-shadow\\)\\/0\\.16\\)\\] {
  --tw-shadow: inset 0 1px 0 rgb(var(--pm-gold)/0.08),0 8px 22px rgb(var(--color-shadow)/0.16);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 8px 22px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-\\[rgba\\(0\\2c 0\\2c 0\\2c 0\\.25\\)_0_5px_8px_-4px\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.18\\)_0_0_20px_0\\2c rgba\\(0\\2c 0\\2c 0\\2c 0\\.35\\)_0_40px_34px_-16px\\] {
  --tw-shadow: rgba(0,0,0,0.25) 0 5px 8px -4px,rgba(0,0,0,0.18) 0 0 20px 0,rgba(0,0,0,0.35) 0 40px 34px -16px;
  --tw-shadow-colored: 0 5px 8px -4px var(--tw-shadow-color), 0 0 20px 0 var(--tw-shadow-color), 0 40px 34px -16px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-card {
  --tw-shadow: inset 0 1px 0 rgb(var(--pm-gold) / 0.08);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-dropdown {
  --tw-shadow: 0 10px 24px rgb(var(--color-shadow) / 0.55);
  --tw-shadow-colored: 0 10px 24px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-gold {
  --tw-shadow: 0 2px 8px rgb(var(--pm-gold) / 0.28);
  --tw-shadow-colored: 0 2px 8px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-inner {
  --tw-shadow: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: inset 0 2px 4px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-gold {
  --tw-shadow-color: #EFD43C;
  --tw-shadow: var(--tw-shadow-colored);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-saturate-\\[1\\.2\\] {
  --tw-backdrop-saturate: saturate(1.2);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background\\2c border-color\\2c opacity\\] {
  transition-property: background,border-color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background\\2c color\\2c border-color\\2c transform\\] {
  transition-property: background,color,border-color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background\\2c color\\2c border-color\\] {
  transition-property: background,color,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background\\2c color\\] {
  transition-property: background,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c color\\2c border-color\\] {
  transition-property: background-color,color,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c color\\2c transform\\] {
  transition-property: background-color,color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[background-color\\2c color\\] {
  transition-property: background-color,color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c box-shadow\\2c transform\\] {
  transition-property: border-color,box-shadow,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border-color\\2c transform\\] {
  transition-property: border-color,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[border\\] {
  transition-property: border;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[box-shadow\\2c border-color\\] {
  transition-property: box-shadow,border-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c background-color\\] {
  transition-property: color,background-color;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[color\\2c opacity\\] {
  transition-property: color,opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[grid-template-rows\\] {
  transition-property: grid-template-rows;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[left\\] {
  transition-property: left;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c box-shadow\\] {
  transition-property: opacity,box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\2c background\\] {
  transition-property: opacity,transform,background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c transform\\] {
  transition-property: opacity,transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[width\\2c background\\] {
  transition-property: width,background;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-150 {
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-\\[0\\.16s\\] {
  transition-duration: 0.16s;
}
.duration-\\[0\\.18s\\] {
  transition-duration: 0.18s;
}
.duration-\\[400ms\\] {
  transition-duration: 400ms;
}
.ease-\\[cubic-bezier\\(0\\.34\\2c 1\\.2\\2c 0\\.64\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.34,1.2,0.64,1);
}
.ease-\\[cubic-bezier\\(0\\.4\\2c 0\\2c 0\\.2\\2c 1\\)\\] {
  transition-timing-function: cubic-bezier(0.4,0,0.2,1);
}
.ease-\\[ease\\] {
  transition-timing-function: ease;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
.\\[--order-panel-bottom-pad\\:16px\\] {
  --order-panel-bottom-pad: 16px;
}
.\\[--order-panel-max-h\\:calc\\(100dvh-var\\(--pm-header-offset\\2c 140px\\)-var\\(--order-panel-top\\)-var\\(--order-panel-bottom-pad\\)\\)\\] {
  --order-panel-max-h: calc(100dvh - var(--pm-header-offset,140px) - var(--order-panel-top) - var(--order-panel-bottom-pad));
}
.\\[--order-panel-top\\:12px\\] {
  --order-panel-top: 12px;
}
.\\[-ms-overflow-style\\:auto\\] {
  -ms-overflow-style: auto;
}
.\\[-webkit-box-orient\\:vertical\\] {
  -webkit-box-orient: vertical;
}
.\\[-webkit-line-clamp\\:2\\] {
  -webkit-line-clamp: 2;
}
.\\[-webkit-mask-image\\:linear-gradient\\(90deg\\2c transparent_0\\2c \\#000_12px\\2c \\#000_calc\\(100\\%-18px\\)\\2c transparent\\)\\] {
  -webkit-mask-image: linear-gradient(90deg,transparent 0,#000 12px,#000 calc(100% - 18px),transparent);
}
.\\[-webkit-overflow-scrolling\\:touch\\] {
  -webkit-overflow-scrolling: touch;
}
.\\[animation-delay\\:0\\.12s\\] {
  animation-delay: 0.12s;
}
.\\[animation-delay\\:0\\.14s\\] {
  animation-delay: 0.14s;
}
.\\[animation-delay\\:0\\.1s\\] {
  animation-delay: 0.1s;
}
.\\[backdrop-filter\\:blur\\(3px\\)\\] {
  backdrop-filter: blur(3px);
}
.\\[background-position\\:calc\\(100\\%-10px\\)_50\\%\\] {
  background-position: calc(100% - 10px) 50%;
}
.\\[background\\:linear-gradient\\(145deg\\2c \\#472e00\\2c \\#090b0b_25\\%\\)_padding-box\\2c linear-gradient\\(135deg\\2c \\#8a6500\\2c \\#ffd700\\2c \\#b8860b\\2c \\#b8860b\\2c \\#8a6500\\)_border-box\\] {
  background: linear-gradient(145deg,#472e00,#090b0b 25%) padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500) border-box;
}
.\\[display\\:-webkit-box\\] {
  display: -webkit-box;
}
.\\[filter\\:drop-shadow\\(0_140px_50px_\\#FAD400\\)\\] {
  filter: drop-shadow(0 140px 50px #FAD400);
}
.\\[font-family\\:inherit\\] {
  font-family: inherit;
}
.\\[mask-image\\:linear-gradient\\(90deg\\2c transparent_0\\2c \\#000_12px\\2c \\#000_calc\\(100\\%-18px\\)\\2c transparent\\)\\] {
  mask-image: linear-gradient(90deg,transparent 0,#000 12px,#000 calc(100% - 18px),transparent);
}
.\\[scrollbar-color\\:rgb\\(var\\(--color-line-strong\\)\\)_transparent\\] {
  scrollbar-color: rgb(var(--color-line-strong)) transparent;
}
.\\[scrollbar-width\\:none\\] {
  scrollbar-width: none;
}
.\\[scrollbar-width\\:thin\\] {
  scrollbar-width: thin;
}
.\\[text-wrap\\:nowrap\\] {
  text-wrap: nowrap;
}
.\\[transform-box\\:fill-box\\] {
  transform-box: fill-box;
}
.\\[transition\\:box-shadow_var\\(--pm-duration-fast\\2c 0\\.16s\\)_var\\(--pm-ease\\2c ease\\)\\2c transform_var\\(--pm-duration\\2c 0\\.24s\\)_var\\(--pm-ease-spring\\2c ease\\)\\] {
  transition: box-shadow var(--pm-duration-fast,0.16s) var(--pm-ease,ease),transform var(--pm-duration,0.24s) var(--pm-ease-spring,ease);
}
html,
body {
  padding: 0;
  margin: 0;
}
.file\\:mr-2::file-selector-button {
  margin-right: 0.5rem;
}
.file\\:rounded-lg::file-selector-button {
  border-radius: 0.5rem;
}
.file\\:border-0::file-selector-button {
  border-width: 0px;
}
.file\\:bg-white\\/10::file-selector-button {
  background-color: rgb(255 255 255 / 0.1);
}
.file\\:px-3::file-selector-button {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.file\\:py-1::file-selector-button {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.file\\:text-xs::file-selector-button {
  font-size: 0.75rem;
  line-height: 1rem;
}
.file\\:font-semibold::file-selector-button {
  font-weight: 600;
}
.file\\:text-white::file-selector-button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.placeholder\\:\\!tracking-normal::placeholder {
  letter-spacing: 0em !important;
}
.placeholder\\:\\!text-\\[var\\(--gray-20\\)\\]::placeholder {
  color: var(--gray-20) !important;
}
.placeholder\\:text-\\[var\\(--gray-20\\)\\]::placeholder {
  color: var(--gray-20);
}
.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}
.before\\:inset-y-0::before {
  content: var(--tw-content);
  top: 0px;
  bottom: 0px;
}
.before\\:bottom-3::before {
  content: var(--tw-content);
  bottom: 0.75rem;
}
.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}
.before\\:top-3::before {
  content: var(--tw-content);
  top: 0.75rem;
}
.before\\:w-0\\.5::before {
  content: var(--tw-content);
  width: 0.125rem;
}
.before\\:w-\\[3px\\]::before {
  content: var(--tw-content);
  width: 3px;
}
.before\\:rounded-full::before {
  content: var(--tw-content);
  border-radius: 9999px;
}
.before\\:bg-danger::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity, 1));
}
.before\\:bg-info\\/70::before {
  content: var(--tw-content);
  background-color: rgb(var(--color-info) / 0.7);
}
.before\\:bg-line-strong::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-line-strong) / var(--tw-bg-opacity, 1));
}
.before\\:opacity-100::before {
  content: var(--tw-content);
  opacity: 1;
}
.before\\:opacity-55::before {
  content: var(--tw-content);
  opacity: 0.55;
}
.before\\:shadow-\\[0_0_12px_rgb\\(var\\(--color-danger\\)\\/0\\.4\\)\\]::before {
  content: var(--tw-content);
  --tw-shadow: 0 0 12px rgb(var(--color-danger)/0.4);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.before\\:content-\\[\\"\\"\\]::before {
  --tw-content: "";
  content: var(--tw-content);
}
.after\\:absolute::after {
  content: var(--tw-content);
  position: absolute;
}
.after\\:inset-x-\\[20\\%\\]::after {
  content: var(--tw-content);
  left: 20%;
  right: 20%;
}
.after\\:bottom-0::after {
  content: var(--tw-content);
  bottom: 0px;
}
.after\\:bottom-full::after {
  content: var(--tw-content);
  bottom: 100%;
}
.after\\:left-1\\/2::after {
  content: var(--tw-content);
  left: 50%;
}
.after\\:right-3::after {
  content: var(--tw-content);
  right: 0.75rem;
}
.after\\:top-full::after {
  content: var(--tw-content);
  top: 100%;
}
.after\\:ml-\\[-5px\\]::after {
  content: var(--tw-content);
  margin-left: -5px;
}
.after\\:hidden::after {
  content: var(--tw-content);
  display: none;
}
.after\\:h-0\\.5::after {
  content: var(--tw-content);
  height: 0.125rem;
}
.after\\:scale-x-0::after {
  content: var(--tw-content);
  --tw-scale-x: 0;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:scale-x-100::after {
  content: var(--tw-content);
  --tw-scale-x: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.after\\:rounded-t-sm::after {
  content: var(--tw-content);
  border-top-left-radius: 0.125rem;
  border-top-right-radius: 0.125rem;
}
.after\\:border-\\[5px\\]::after {
  content: var(--tw-content);
  border-width: 5px;
}
.after\\:border-transparent::after {
  content: var(--tw-content);
  border-color: transparent;
}
.after\\:border-b-ink::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-bottom-color: rgb(var(--color-ink) / var(--tw-border-opacity, 1));
}
.after\\:border-t-ink::after {
  content: var(--tw-content);
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--color-ink) / var(--tw-border-opacity, 1));
}
.after\\:bg-accent::after {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-accent) / var(--tw-bg-opacity, 1));
}
.after\\:transition-transform::after {
  content: var(--tw-content);
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.after\\:duration-\\[0\\.28s\\]::after {
  content: var(--tw-content);
  transition-duration: 0.28s;
}
.after\\:ease-\\[cubic-bezier\\(0\\.34\\2c 1\\.2\\2c 0\\.64\\2c 1\\)\\]::after {
  content: var(--tw-content);
  transition-timing-function: cubic-bezier(0.34,1.2,0.64,1);
}
.after\\:content-\\[\\"\\"\\]::after {
  --tw-content: "";
  content: var(--tw-content);
}
.after\\:content-\\[\\'\\'\\]::after {
  --tw-content: '';
  content: var(--tw-content);
}
.first\\:ml-0:first-child {
  margin-left: 0px;
}
.first\\:mt-0:first-child {
  margin-top: 0px;
}
.read-only\\:bg-\\[var\\(--gray-90\\)\\]:read-only {
  background-color: var(--gray-90);
}
.read-only\\:text-\\[var\\(--white\\)\\]:read-only {
  color: var(--white);
}
.read-only\\:text-white:read-only {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.focus-within\\:shadow-none:focus-within {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:-translate-y-0\\.5:hover {
  --tw-translate-y: -0.125rem;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:-translate-y-px:hover {
  --tw-translate-y: -1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:transform-none:hover {
  transform: none;
}
.hover\\:\\!border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.55\\)\\]:hover {
  border-color: rgb(var(--pm-gold)/0.55) !important;
}
.hover\\:border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.25\\)\\]:hover {
  border-color: rgb(var(--pm-gold)/0.25);
}
.hover\\:border-\\[rgb\\(var\\(--pm-gold\\)\\/0\\.45\\)\\]:hover {
  border-color: rgb(var(--pm-gold)/0.45);
}
.hover\\:border-gold-dark:hover {
  --tw-border-opacity: 1;
  border-color: rgb(203 125 0 / var(--tw-border-opacity, 1));
}
.hover\\:border-gold\\/35:hover {
  border-color: rgb(239 212 60 / 0.35);
}
.hover\\:border-gold\\/60:hover {
  border-color: rgb(239 212 60 / 0.6);
}
.hover\\:border-line:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-line) / var(--tw-border-opacity, 1));
}
.hover\\:border-line-strong:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-line-strong) / var(--tw-border-opacity, 1));
}
.hover\\:border-transparent:hover {
  border-color: transparent;
}
.hover\\:\\!bg-\\[rgb\\(var\\(--pm-felt\\)\\/0\\.35\\)\\]:hover {
  background-color: rgb(var(--pm-felt)/0.35) !important;
}
.hover\\:bg-\\[\\#ffffff0a\\]:hover {
  background-color: #ffffff0a;
}
.hover\\:bg-\\[rgb\\(var\\(--color-warning-soft\\)\\/var\\(--tw-bg-opacity\\2c 1\\)\\)\\]:hover {
  background-color: rgb(var(--color-warning-soft)/var(--tw-bg-opacity,1));
}
.hover\\:bg-\\[var\\(--gray-80\\)\\]:hover {
  background-color: var(--gray-80);
}
.hover\\:bg-\\[var\\(--gray-85\\)\\]:hover {
  background-color: var(--gray-85);
}
.hover\\:bg-\\[var\\(--secondaryBtn\\)\\]:hover {
  background-color: var(--secondaryBtn);
}
.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-info\\/10:hover {
  background-color: rgb(var(--color-info) / 0.1);
}
.hover\\:bg-ink-faint:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-ink-faint) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-line:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-line) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-surface-muted:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-muted) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-surface-overlay:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-overlay) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-surface-overlay\\/55:hover {
  background-color: rgb(var(--color-surface-overlay) / 0.55);
}
.hover\\:bg-transparent:hover {
  background-color: transparent;
}
.hover\\:bg-warning-soft:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning-soft) / var(--tw-bg-opacity, 1));
}
.hover\\:bg-white\\/10:hover {
  background-color: rgb(255 255 255 / 0.1);
}
.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:bg-\\[linear-gradient\\(\\#EFD43C\\2c \\#CB7D00\\)\\]:hover {
  background-image: linear-gradient(#EFD43C,#CB7D00);
}
.hover\\:bg-gold-btn:hover {
  background-image: linear-gradient(#EFD43C, #CB7D00);
}
.hover\\:\\!text-\\[rgb\\(var\\(--pm-gold\\)\\)\\]:hover {
  color: rgb(var(--pm-gold)) !important;
}
.hover\\:text-\\[var\\(--white\\)\\]:hover {
  color: var(--white);
}
.hover\\:text-gold-bright:hover {
  --tw-text-opacity: 1;
  color: rgb(252 212 67 / var(--tw-text-opacity, 1));
}
.hover\\:text-ink:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink) / var(--tw-text-opacity, 1));
}
.hover\\:text-ink-muted:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink-muted) / var(--tw-text-opacity, 1));
}
.hover\\:text-ink-soft:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink-soft) / var(--tw-text-opacity, 1));
}
.hover\\:text-warning-contrast:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning-contrast) / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.hover\\:opacity-100:hover {
  opacity: 1;
}
.hover\\:opacity-90:hover {
  opacity: 0.9;
}
.hover\\:opacity-\\[0\\.88\\]:hover {
  opacity: 0.88;
}
.hover\\:opacity-\\[0\\.94\\]:hover {
  opacity: 0.94;
}
.hover\\:shadow-\\[0_-12px_40px_rgb\\(var\\(--color-shadow\\)\\/0\\.18\\)\\]:hover {
  --tw-shadow: 0 -12px 40px rgb(var(--color-shadow)/0.18);
  --tw-shadow-colored: 0 -12px 40px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[0_8px_22px_rgb\\(var\\(--color-shadow\\)\\/0\\.1\\)\\]:hover {
  --tw-shadow: 0 8px 22px rgb(var(--color-shadow)/0.1);
  --tw-shadow-colored: 0 8px 22px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[inset_0_1px_0_rgb\\(var\\(--pm-gold\\)\\/0\\.1\\)\\2c 0_6px_18px_rgb\\(var\\(--color-shadow\\)\\/0\\.18\\)\\]:hover {
  --tw-shadow: inset 0 1px 0 rgb(var(--pm-gold)/0.1),0 6px 18px rgb(var(--color-shadow)/0.18);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 6px 18px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-\\[inset_0_1px_0_rgb\\(var\\(--pm-gold\\)\\/0\\.12\\)\\2c 0_10px_28px_rgb\\(var\\(--color-shadow\\)\\/0\\.2\\)\\]:hover {
  --tw-shadow: inset 0 1px 0 rgb(var(--pm-gold)/0.12),0 10px 28px rgb(var(--color-shadow)/0.2);
  --tw-shadow-colored: inset 0 1px 0 var(--tw-shadow-color), 0 10px 28px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:shadow-none:hover {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.hover\\:brightness-110:hover {
  --tw-brightness: brightness(1.1);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.hover\\:\\[background\\:linear-gradient\\(145deg\\2c \\#472e00\\2c \\#090b0b_35\\%\\)_padding-box\\2c linear-gradient\\(135deg\\2c \\#8a6500\\2c \\#ffd700\\2c \\#b8860b\\2c \\#b8860b\\2c \\#8a6500\\)_border-box\\]:hover {
  background: linear-gradient(145deg,#472e00,#090b0b 35%) padding-box,linear-gradient(135deg,#8a6500,#ffd700,#b8860b,#b8860b,#8a6500) border-box;
}
.hover\\:file\\:bg-white\\/20::file-selector-button:hover {
  background-color: rgb(255 255 255 / 0.2);
}
.hover\\:before\\:bg-danger:hover::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity, 1));
}
.hover\\:before\\:opacity-100:hover::before {
  content: var(--tw-content);
  opacity: 1;
}
.hover\\:before\\:shadow-\\[0_0_12px_rgb\\(var\\(--color-danger\\)\\/0\\.4\\)\\]:hover::before {
  content: var(--tw-content);
  --tw-shadow: 0 0 12px rgb(var(--color-danger)/0.4);
  --tw-shadow-colored: 0 0 12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:\\!border-\\[var\\(--blue-300\\)\\]:focus {
  border-color: var(--blue-300) !important;
}
.focus\\:\\!border-\\[var\\(--c\\)\\]:focus {
  border-color: var(--c) !important;
}
.focus\\:\\!border-\\[var\\(--red\\)\\]:focus {
  border-color: var(--red) !important;
}
.focus\\:border-\\[\\#f7b731\\]:focus {
  --tw-border-opacity: 1;
  border-color: rgb(247 183 49 / var(--tw-border-opacity, 1));
}
.focus\\:border-\\[var\\(--blue-300\\)\\]:focus {
  border-color: var(--blue-300);
}
.focus\\:border-transparent:focus {
  border-color: transparent;
}
.focus\\:bg-\\[var\\(--darkGray\\)\\]:focus {
  background-color: var(--darkGray);
}
.focus\\:bg-\\[var\\(--gray-90\\)\\]:focus {
  background-color: var(--gray-90);
}
.focus\\:bg-\\[linear-gradient\\(\\#EFD43C\\2c \\#CB7D00\\)\\]:focus {
  background-image: linear-gradient(#EFD43C,#CB7D00);
}
.focus\\:bg-gold-btn:focus {
  background-image: linear-gradient(#EFD43C, #CB7D00);
}
.focus\\:text-\\[var\\(--white\\)\\]:focus {
  color: var(--white);
}
.focus\\:text-white:focus {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.focus\\:shadow-none:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.focus-visible\\:rounded:focus-visible {
  border-radius: 0.25rem;
}
.focus-visible\\:shadow-\\[0_0_0_2px_rgb\\(var\\(--color-ink-faint\\)\\)\\]:focus-visible {
  --tw-shadow: 0 0 0 2px rgb(var(--color-ink-faint));
  --tw-shadow-colored: 0 0 0 2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.focus-visible\\:outline:focus-visible {
  outline-style: solid;
}
.focus-visible\\:outline-2:focus-visible {
  outline-width: 2px;
}
.focus-visible\\:outline-offset-2:focus-visible {
  outline-offset: 2px;
}
.focus-visible\\:outline-info:focus-visible {
  outline-color: rgb(var(--color-info) / 1);
}
.active\\:translate-y-px:active {
  --tw-translate-y: 1px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:scale-\\[0\\.98\\]:active {
  --tw-scale-x: 0.98;
  --tw-scale-y: 0.98;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.active\\:bg-\\[linear-gradient\\(\\#EFD43C\\2c \\#CB7D00\\)\\]:active {
  background-image: linear-gradient(#EFD43C,#CB7D00);
}
.active\\:bg-gold-btn:active {
  background-image: linear-gradient(#EFD43C, #CB7D00);
}
.active\\:text-white:active {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.active\\:opacity-80:active {
  opacity: 0.8;
}
.enabled\\:hover\\:bg-surface-overlay:hover:enabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-overlay) / var(--tw-bg-opacity, 1));
}
.enabled\\:hover\\:text-ink:hover:enabled {
  --tw-text-opacity: 1;
  color: rgb(var(--color-ink) / var(--tw-text-opacity, 1));
}
.enabled\\:hover\\:opacity-\\[0\\.92\\]:hover:enabled {
  opacity: 0.92;
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-\\[var\\(--gray-90\\)\\]:disabled {
  background-color: var(--gray-90);
}
.disabled\\:bg-surface-overlay:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-surface-overlay) / var(--tw-bg-opacity, 1));
}
.disabled\\:bg-\\[linear-gradient\\(\\#EFD43C\\2c \\#CB7D00\\)\\]:disabled {
  background-image: linear-gradient(#EFD43C,#CB7D00);
}
.disabled\\:text-\\[var\\(--white\\)\\]:disabled {
  color: var(--white);
}
.disabled\\:text-white:disabled {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}
.disabled\\:opacity-\\[0\\.55\\]:disabled {
  opacity: 0.55;
}
.group:hover .group-hover\\:inline {
  display: inline;
}
.group:hover .group-hover\\:hidden {
  display: none;
}
.group:hover .group-hover\\:scale-100 {
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:scale-\\[1\\.04\\] {
  --tw-scale-x: 1.04;
  --tw-scale-y: 1.04;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.group:hover .group-hover\\:bg-\\[var\\(--gray-80\\)\\] {
  background-color: var(--gray-80);
}
.group:hover .group-hover\\:opacity-100 {
  opacity: 1;
}
.group:hover .group-hover\\:\\[animation-play-state\\:paused\\] {
  animation-play-state: paused;
}
.peer:checked ~ .peer-checked\\:left-5 {
  left: 1.25rem;
}
.peer:checked ~ .peer-checked\\:translate-x-\\[19px\\] {
  --tw-translate-x: 19px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.peer:checked ~ .peer-checked\\:bg-\\[var\\(--gray-90\\)\\] {
  background-color: var(--gray-90);
}
.peer:checked ~ .peer-checked\\:bg-\\[var\\(--live-green\\)\\] {
  background-color: var(--live-green);
}
.peer:checked ~ .peer-checked\\:bg-\\[var\\(--white\\)\\] {
  background-color: var(--white);
}
@media (prefers-reduced-motion: reduce) {
  .motion-reduce\\:transform-none {
    transform: none;
  }
  .motion-reduce\\:animate-none {
    animation: none;
  }
  .motion-reduce\\:transition-none {
    transition-property: none;
  }
}
@media (max-width: 1800px) {
  .max-\\[1800px\\]\\:flex-wrap {
    flex-wrap: wrap;
  }
  .max-\\[1800px\\]\\:items-center {
    align-items: center;
  }
}
@media (max-width: 1200px) {
  .max-\\[1200px\\]\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .max-\\[1200px\\]\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}
@media not all and (min-width: 1024px) {
  .max-lg\\:m-0 {
    margin: 0px;
  }
  .max-lg\\:m-1 {
    margin: 0.25rem;
  }
  .max-lg\\:mr-0 {
    margin-right: 0px;
  }
  .max-lg\\:mt-0 {
    margin-top: 0px;
  }
  .max-lg\\:mt-1 {
    margin-top: 0.25rem;
  }
  .max-lg\\:mt-4 {
    margin-top: 1rem;
  }
  .max-lg\\:block {
    display: block;
  }
  .max-lg\\:w-full {
    width: 100%;
  }
  .max-lg\\:min-w-0 {
    min-width: 0px;
  }
  .max-lg\\:min-w-full {
    min-width: 100%;
  }
  .max-lg\\:max-w-full {
    max-width: 100%;
  }
  .max-lg\\:basis-full {
    flex-basis: 100%;
  }
  .max-lg\\:flex-col {
    flex-direction: column;
  }
  .max-lg\\:rounded-none {
    border-radius: 0px;
  }
  .max-lg\\:border-0 {
    border-width: 0px;
  }
  .max-lg\\:border-r-0 {
    border-right-width: 0px;
  }
  .max-lg\\:p-0 {
    padding: 0px;
  }
  .max-lg\\:pb-4 {
    padding-bottom: 1rem;
  }
  .max-lg\\:pl-0 {
    padding-left: 0px;
  }
  .max-lg\\:pt-8 {
    padding-top: 2rem;
  }
  .max-lg\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .max-lg\\:text-\\[var\\(--white\\)\\] {
    color: var(--white);
  }
}
@media (max-width: 992px) {
  .max-\\[992px\\]\\:h-auto {
    height: auto;
  }
  .max-\\[992px\\]\\:max-w-none {
    max-width: none;
  }
  .max-\\[992px\\]\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .max-\\[992px\\]\\:rounded-xl {
    border-radius: 0.75rem;
  }
  .max-\\[992px\\]\\:text-\\[13px\\] {
    font-size: 13px;
  }
  .max-\\[992px\\]\\:shadow-\\[0_4px_20px_rgb\\(var\\(--color-shadow\\)\\/0\\.06\\)\\] {
    --tw-shadow: 0 4px 20px rgb(var(--color-shadow)/0.06);
    --tw-shadow-colored: 0 4px 20px var(--tw-shadow-color);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}
@media (max-width: 900px) {
  .max-\\[900px\\]\\:\\[-ms-overflow-style\\:none\\] {
    -ms-overflow-style: none;
  }
  .max-\\[900px\\]\\:\\[scrollbar-width\\:none\\] {
    scrollbar-width: none;
  }
}
@media not all and (min-width: 768px) {
  .max-md\\:m-0 {
    margin: 0px;
  }
  .max-md\\:my-4 {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .max-md\\:mb-4 {
    margin-bottom: 1rem;
  }
  .max-md\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .max-md\\:ml-0 {
    margin-left: 0px;
  }
  .max-md\\:mt-4 {
    margin-top: 1rem;
  }
  .max-md\\:mt-6 {
    margin-top: 1.5rem;
  }
  .max-md\\:hidden {
    display: none;
  }
  .max-md\\:min-h-10 {
    min-height: 2.5rem;
  }
  .max-md\\:w-\\[100px\\] {
    width: 100px;
  }
  .max-md\\:w-full {
    width: 100%;
  }
  .max-md\\:min-w-\\[106px\\] {
    min-width: 106px;
  }
  .max-md\\:max-w-full {
    max-width: 100%;
  }
  .max-md\\:flex-col {
    flex-direction: column;
  }
  .max-md\\:items-start {
    align-items: flex-start;
  }
  .max-md\\:justify-center {
    justify-content: center;
  }
  .max-md\\:gap-y-4 {
    row-gap: 1rem;
  }
  .max-md\\:overflow-x-auto {
    overflow-x: auto;
  }
  .max-md\\:whitespace-nowrap {
    white-space: nowrap;
  }
  .max-md\\:border-b {
    border-bottom-width: 1px;
  }
  .max-md\\:border-\\[var\\(--gray-80\\)\\] {
    border-color: var(--gray-80);
  }
  .max-md\\:p-0 {
    padding: 0px;
  }
  .max-md\\:p-4 {
    padding: 1rem;
  }
  .max-md\\:pb-2\\.5 {
    padding-bottom: 0.625rem;
  }
  .max-md\\:pb-5 {
    padding-bottom: 1.25rem;
  }
  .max-md\\:pr-\\[5\\.7rem\\] {
    padding-right: 5.7rem;
  }
  .max-md\\:pr-\\[6\\.875rem\\] {
    padding-right: 6.875rem;
  }
  .max-md\\:pt-10 {
    padding-top: 2.5rem;
  }
  .max-md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .max-md\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (max-width: 768px) {
  .max-\\[768px\\]\\:static {
    position: static;
  }
  .max-\\[768px\\]\\:h-\\[32px\\] {
    height: 32px;
  }
  .max-\\[768px\\]\\:w-auto {
    width: auto;
  }
  .max-\\[768px\\]\\:w-full {
    width: 100%;
  }
  .max-\\[768px\\]\\:min-w-\\[32px\\] {
    min-width: 32px;
  }
  .max-\\[768px\\]\\:min-w-\\[34px\\] {
    min-width: 34px;
  }
  .max-\\[768px\\]\\:max-w-none {
    max-width: none;
  }
  .max-\\[768px\\]\\:flex-\\[1_1_auto\\] {
    flex: 1 1 auto;
  }
  @keyframes pm-sheet-slide-up {
    from {
      opacity: 0;
      transform: translateY(100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
    from {
      opacity: 0;
      transform: translateY(100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  .max-\\[768px\\]\\:animate-pm-sheet-slide-up {
    animation: pm-sheet-slide-up 0.28s ease both;
  }
  .max-\\[768px\\]\\:grid-cols-1 {
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }
  .max-\\[768px\\]\\:flex-row {
    flex-direction: row;
  }
  .max-\\[768px\\]\\:flex-col-reverse {
    flex-direction: column-reverse;
  }
  .max-\\[768px\\]\\:flex-wrap {
    flex-wrap: wrap;
  }
  .max-\\[768px\\]\\:items-end {
    align-items: flex-end;
  }
  .max-\\[768px\\]\\:justify-center {
    justify-content: center;
  }
  .max-\\[768px\\]\\:gap-1\\.5 {
    gap: 0.375rem;
  }
  .max-\\[768px\\]\\:gap-3 {
    gap: 0.75rem;
  }
  .max-\\[768px\\]\\:rounded-\\[16px_16px_0_0\\] {
    border-radius: 16px 16px 0 0;
  }
  .max-\\[768px\\]\\:rounded-full {
    border-radius: 9999px;
  }
  .max-\\[768px\\]\\:p-0 {
    padding: 0px;
  }
  .max-\\[768px\\]\\:p-2 {
    padding: 0.5rem;
  }
  .max-\\[768px\\]\\:p-2\\.5 {
    padding: 0.625rem;
  }
  .max-\\[768px\\]\\:px-2\\.5 {
    padding-left: 0.625rem;
    padding-right: 0.625rem;
  }
  .max-\\[768px\\]\\:px-4 {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  .max-\\[768px\\]\\:py-1\\.5 {
    padding-top: 0.375rem;
    padding-bottom: 0.375rem;
  }
  .max-\\[768px\\]\\:pb-\\[calc\\(16px\\+env\\(safe-area-inset-bottom\\2c 0px\\)\\)\\] {
    padding-bottom: calc(16px + env(safe-area-inset-bottom,0px));
  }
  .max-\\[768px\\]\\:pt-\\[18px\\] {
    padding-top: 18px;
  }
  .max-\\[768px\\]\\:text-\\[11px\\] {
    font-size: 11px;
  }
  .max-\\[768px\\]\\:text-\\[13px\\] {
    font-size: 13px;
  }
  .max-\\[768px\\]\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (max-width: 700px) {
  .max-\\[700px\\]\\:right-3 {
    right: 0.75rem;
  }
  .max-\\[700px\\]\\:top-2\\.5 {
    top: 0.625rem;
  }
  .max-\\[700px\\]\\:h-\\[220px\\] {
    height: 220px;
  }
  .max-\\[700px\\]\\:min-h-9 {
    min-height: 2.25rem;
  }
  .max-\\[700px\\]\\:min-h-\\[4\\.2em\\] {
    min-height: 4.2em;
  }
  .max-\\[700px\\]\\:rounded-\\[20px\\] {
    border-radius: 20px;
  }
  .max-\\[700px\\]\\:px-\\[18px\\] {
    padding-left: 18px;
    padding-right: 18px;
  }
  .max-\\[700px\\]\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .max-\\[700px\\]\\:pb-7 {
    padding-bottom: 1.75rem;
  }
  .max-\\[700px\\]\\:pb-\\[18px\\] {
    padding-bottom: 18px;
  }
  .max-\\[700px\\]\\:pl-3\\.5 {
    padding-left: 0.875rem;
  }
  .max-\\[700px\\]\\:pr-\\[52px\\] {
    padding-right: 52px;
  }
  .max-\\[700px\\]\\:pt-1\\.5 {
    padding-top: 0.375rem;
  }
  .max-\\[700px\\]\\:pt-3\\.5 {
    padding-top: 0.875rem;
  }
  .max-\\[700px\\]\\:text-\\[0\\.9rem\\] {
    font-size: 0.9rem;
  }
  .max-\\[700px\\]\\:text-\\[1\\.25rem\\] {
    font-size: 1.25rem;
  }
  .max-\\[700px\\]\\:text-\\[1\\.2rem\\] {
    font-size: 1.2rem;
  }
  .max-\\[700px\\]\\:text-\\[12\\.5px\\] {
    font-size: 12.5px;
  }
  .max-\\[700px\\]\\:text-\\[13\\.5px\\] {
    font-size: 13.5px;
  }
  .max-\\[700px\\]\\:text-\\[13px\\] {
    font-size: 13px;
  }
}
@media not all and (min-width: 640px) {
  .max-sm\\:mr-2 {
    margin-right: 0.5rem;
  }
  .max-sm\\:h-10 {
    height: 2.5rem;
  }
  .max-sm\\:h-full {
    height: 100%;
  }
  .max-sm\\:min-h-10 {
    min-height: 2.5rem;
  }
  .max-sm\\:min-h-16 {
    min-height: 4rem;
  }
  .max-sm\\:min-h-8 {
    min-height: 2rem;
  }
  .max-sm\\:w-10 {
    width: 2.5rem;
  }
  .max-sm\\:min-w-0 {
    min-width: 0px;
  }
  .max-sm\\:max-w-none {
    max-width: none;
  }
  .max-sm\\:p-0 {
    padding: 0px;
  }
  .max-sm\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .max-sm\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .max-sm\\:py-1 {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }
  .max-sm\\:py-2 {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .max-sm\\:pb-4 {
    padding-bottom: 1rem;
  }
  .max-sm\\:pb-8 {
    padding-bottom: 2rem;
  }
  .max-sm\\:pt-3 {
    padding-top: 0.75rem;
  }
  .max-sm\\:text-start {
    text-align: start;
  }
  .max-sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .max-sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .max-sm\\:leading-4 {
    line-height: 1rem;
  }
  .max-sm\\:leading-6 {
    line-height: 1.5rem;
  }
}
@media (max-width: 640px) {
  .max-\\[640px\\]\\:min-h-\\[52px\\] {
    min-height: 52px;
  }
  .max-\\[640px\\]\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .max-\\[640px\\]\\:py-2\\.5 {
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
  }
  .max-\\[640px\\]\\:text-\\[15px\\] {
    font-size: 15px;
  }
  .max-\\[640px\\]\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
@media (max-width: 600px) {
  .max-\\[600px\\]\\:w-full {
    width: 100%;
  }
}
@media (max-width: 576px) {
  .max-\\[576px\\]\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }
  .max-\\[576px\\]\\:mr-0 {
    margin-right: 0px;
  }
  .max-\\[576px\\]\\:min-w-\\[340px\\] {
    min-width: 340px;
  }
}
@media (max-width: 480px) {
  .max-\\[480px\\]\\:mt-2 {
    margin-top: 0.5rem;
  }
  .max-\\[480px\\]\\:px-1 {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
  .max-\\[480px\\]\\:px-2 {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .max-\\[480px\\]\\:px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
  .max-\\[480px\\]\\:px-\\[9px\\] {
    padding-left: 9px;
    padding-right: 9px;
  }
  .max-\\[480px\\]\\:py-\\[7px\\] {
    padding-top: 7px;
    padding-bottom: 7px;
  }
  .max-\\[480px\\]\\:pb-3 {
    padding-bottom: 0.75rem;
  }
  .max-\\[480px\\]\\:pb-\\[5px\\] {
    padding-bottom: 5px;
  }
  .max-\\[480px\\]\\:pl-1 {
    padding-left: 0.25rem;
  }
  .max-\\[480px\\]\\:pt-2\\.5 {
    padding-top: 0.625rem;
  }
  .max-\\[480px\\]\\:text-\\[11px\\] {
    font-size: 11px;
  }
  .max-\\[480px\\]\\:text-\\[20px\\] {
    font-size: 20px;
  }
  .max-\\[480px\\]\\:text-\\[9px\\] {
    font-size: 9px;
  }
  .max-\\[480px\\]\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .max-\\[480px\\]\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}
@media (min-width: 576px) {
  .min-\\[576px\\]\\:block {
    display: block;
  }
  .min-\\[576px\\]\\:flex {
    display: flex;
  }
}
@media (min-width: 640px) {
  .sm\\:z-\\[1060\\] {
    z-index: 1060;
  }
  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }
  .sm\\:col-span-6 {
    grid-column: span 6 / span 6;
  }
  .sm\\:mb-4 {
    margin-bottom: 1rem;
  }
  .sm\\:block {
    display: block;
  }
  .sm\\:hidden {
    display: none;
  }
  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }
  .sm\\:p-8 {
    padding: 2rem;
  }
  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
}
@media (min-width: 768px) {
  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }
  .md\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }
  .md\\:my-7 {
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }
  .md\\:mb-2 {
    margin-bottom: 0.5rem;
  }
  .md\\:mb-4 {
    margin-bottom: 1rem;
  }
  .md\\:mb-5 {
    margin-bottom: 1.25rem;
  }
  .md\\:mb-6 {
    margin-bottom: 1.5rem;
  }
  .md\\:block {
    display: block;
  }
  .md\\:flex {
    display: flex;
  }
  .md\\:hidden {
    display: none;
  }
  .md\\:max-w-\\[680px\\] {
    max-width: 680px;
  }
  .md\\:items-start {
    align-items: flex-start;
  }
  .md\\:items-center {
    align-items: center;
  }
  .md\\:justify-center {
    justify-content: center;
  }
  .md\\:justify-between {
    justify-content: space-between;
  }
  .md\\:gap-2 {
    gap: 0.5rem;
  }
  .md\\:p-4 {
    padding: 1rem;
  }
  .md\\:p-6 {
    padding: 1.5rem;
  }
  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
  .md\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
  .md\\:px-7 {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
  .md\\:py-5 {
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }
  .md\\:py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .md\\:py-8 {
    padding-top: 2rem;
    padding-bottom: 2rem;
  }
  .md\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }
  .md\\:text-\\[1\\.05rem\\] {
    font-size: 1.05rem;
  }
  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .md\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}
@media (min-width: 861px) {
  .min-\\[861px\\]\\:grid-cols-\\[minmax\\(0\\2c 1\\.15fr\\)_minmax\\(0\\2c 0\\.85fr\\)\\] {
    grid-template-columns: minmax(0,1.15fr) minmax(0,0.85fr);
  }
}
@media (min-width: 992px) {
  .min-\\[992px\\]\\:block {
    display: block;
  }
  .min-\\[992px\\]\\:w-5\\/12 {
    width: 41.666667%;
  }
  .min-\\[992px\\]\\:w-7\\/12 {
    width: 58.333333%;
  }
}
@media (min-width: 1024px) {
  .lg\\:order-none {
    order: 0;
  }
  .lg\\:col-start-1 {
    grid-column-start: 1;
  }
  .lg\\:col-start-2 {
    grid-column-start: 2;
  }
  .lg\\:row-start-1 {
    grid-row-start: 1;
  }
  .lg\\:row-start-2 {
    grid-row-start: 2;
  }
  .lg\\:block {
    display: block;
  }
  .lg\\:flex {
    display: flex;
  }
  .lg\\:hidden {
    display: none;
  }
  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .lg\\:grid-cols-\\[minmax\\(0\\2c 1fr\\)_minmax\\(0\\2c 1\\.15fr\\)\\] {
    grid-template-columns: minmax(0,1fr) minmax(0,1.15fr);
  }
  .lg\\:grid-cols-\\[minmax\\(0\\2c 2fr\\)_minmax\\(280px\\2c 1fr\\)\\] {
    grid-template-columns: minmax(0,2fr) minmax(280px,1fr);
  }
  .lg\\:flex-row {
    flex-direction: row;
  }
  .lg\\:\\!flex-col {
    flex-direction: column !important;
  }
  .lg\\:items-center {
    align-items: center;
  }
  .lg\\:justify-between {
    justify-content: space-between;
  }
  .lg\\:gap-6 {
    gap: 1.5rem;
  }
  .lg\\:\\!p-0 {
    padding: 0px !important;
  }
  .lg\\:p-6 {
    padding: 1.5rem;
  }
  .lg\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }
  .lg\\:pb-0 {
    padding-bottom: 0px;
  }
  .lg\\:text-\\[1\\.65rem\\] {
    font-size: 1.65rem;
  }
  .lg\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
  .lg\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
  .lg\\:leading-5 {
    line-height: 1.25rem;
  }
  .lg\\:leading-tight {
    line-height: 1.25;
  }
  .lg\\:\\[grid-template-rows\\:minmax\\(460px\\2c auto\\)_auto\\] {
    grid-template-rows: minmax(460px,auto) auto;
  }
}
@media (min-width: 1200px) {
  .min-\\[1200px\\]\\:block {
    display: block;
  }
  .min-\\[1200px\\]\\:hidden {
    display: none;
  }
}
@media (min-width: 1280px) {
  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
@media (min-width: 1400px) {
  .min-\\[1400px\\]\\:mr-px {
    margin-right: 1px;
  }
  .min-\\[1400px\\]\\:block {
    display: block;
  }
  .min-\\[1400px\\]\\:max-w-full {
    max-width: 100%;
  }
  .min-\\[1400px\\]\\:basis-full {
    flex-basis: 100%;
  }
  .min-\\[1400px\\]\\:pl-0 {
    padding-left: 0px;
  }
  .min-\\[1400px\\]\\:pt-8 {
    padding-top: 2rem;
  }
}
@media (max-width: 992px) {
  @media (orientation: landscape) {
    .max-\\[992px\\]\\:landscape\\:max-h-\\[min\\(88dvh\\2c 640px\\)\\] {
      max-height: min(88dvh, 640px);
    }
  }
}
.\\[\\&\\.active\\]\\:bg-\\[var\\(--gray-80\\)\\].active {
  background-color: var(--gray-80);
}
.\\[\\&\\.active\\]\\:text-white.active {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.\\[\\&\\:\\:-webkit-scrollbar-thumb\\:hover\\]\\:bg-ink-faint::-webkit-scrollbar-thumb:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-ink-faint) / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:rounded-sm::-webkit-scrollbar-thumb {
  border-radius: 0.125rem;
}
.\\[\\&\\:\\:-webkit-scrollbar-thumb\\]\\:bg-line-strong::-webkit-scrollbar-thumb {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-line-strong) / var(--tw-bg-opacity, 1));
}
.\\[\\&\\:\\:-webkit-scrollbar-track\\]\\:bg-transparent::-webkit-scrollbar-track {
  background-color: transparent;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
  display: none;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:h-0::-webkit-scrollbar {
  height: 0px;
}
.\\[\\&\\:\\:-webkit-scrollbar\\]\\:h-1::-webkit-scrollbar {
  height: 0.25rem;
}
@media (max-width: 900px) {
  .max-\\[900px\\]\\:\\[\\&\\:\\:-webkit-scrollbar\\]\\:hidden::-webkit-scrollbar {
    display: none;
  }
}
.\\[\\&\\:not\\(\\:first-child\\)\\]\\:ml-2:not(:first-child) {
  margin-left: 0.5rem;
}
.\\[\\&_\\.accordion-animation\\]\\:animate-\\[accordianEffect_400ms_ease-in-out_both\\] .accordion-animation {
  animation: accordianEffect 400ms ease-in-out both;
}
.\\[\\&_\\.accordion-body\\]\\:rounded-b-\\[0\\.875rem\\] .accordion-body {
  border-bottom-right-radius: 0.875rem;
  border-bottom-left-radius: 0.875rem;
}
.\\[\\&_\\.accordion-body\\]\\:bg-\\[var\\(--gray-90\\)\\] .accordion-body {
  background-color: var(--gray-90);
}
.\\[\\&_\\.accordion-body\\]\\:px-0 .accordion-body {
  padding-left: 0px;
  padding-right: 0px;
}
.\\[\\&_\\.accordion-body\\]\\:pb-6 .accordion-body {
  padding-bottom: 1.5rem;
}
.\\[\\&_\\.accordion-body\\]\\:pt-1 .accordion-body {
  padding-top: 0.25rem;
}
.\\[\\&_\\.accordion-body\\]\\:text-base .accordion-body {
  font-size: 1rem;
  line-height: 1.5rem;
}
.\\[\\&_\\.accordion-body\\]\\:text-white .accordion-body {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@media not all and (min-width: 768px) {
  .max-md\\:\\[\\&_\\.accordion-body\\]\\:text-sm .accordion-body {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
}
.\\[\\&_\\.accordion-body_a\\]\\:block .accordion-body a {
  display: block;
}
.\\[\\&_\\.accordion-body_a\\]\\:py-2 .accordion-body a {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.\\[\\&_\\.accordion-body_a\\]\\:text-sm .accordion-body a {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.\\[\\&_\\.accordion-body_a\\]\\:font-medium .accordion-body a {
  font-weight: 500;
}
.\\[\\&_\\.accordion-body_a\\]\\:text-\\[var\\(--gray-20\\)\\] .accordion-body a {
  color: var(--gray-20);
}
.\\[\\&_\\.accordion-button\\.accordionClose\\]\\:\\!text-white .accordion-button.accordionClose {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}
.\\[\\&_\\.accordion-button\\.accordionOpen\\]\\:\\!pb-3 .accordion-button.accordionOpen {
  padding-bottom: 0.75rem !important;
}
.\\[\\&_\\.accordion-button\\:after\\]\\:opacity-0 .accordion-button:after {
  opacity: 0;
}
.\\[\\&_\\.accordion-button\\]\\:relative .accordion-button {
  position: relative;
}
.\\[\\&_\\.accordion-button\\]\\:border-0 .accordion-button {
  border-width: 0px;
}
.\\[\\&_\\.accordion-button\\]\\:border-t .accordion-button {
  border-top-width: 1px;
}
.\\[\\&_\\.accordion-button\\]\\:border-\\[var\\(--gray-80\\)\\] .accordion-button {
  border-color: var(--gray-80);
}
.\\[\\&_\\.accordion-button\\]\\:bg-\\[var\\(--gray-90\\)\\] .accordion-button {
  background-color: var(--gray-90);
}
.\\[\\&_\\.accordion-button\\]\\:px-0 .accordion-button {
  padding-left: 0px;
  padding-right: 0px;
}
.\\[\\&_\\.accordion-button\\]\\:py-4 .accordion-button {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.\\[\\&_\\.accordion-button\\]\\:text-base .accordion-button {
  font-size: 1rem;
  line-height: 1.5rem;
}
.\\[\\&_\\.accordion-button\\]\\:font-medium .accordion-button {
  font-weight: 500;
}
.\\[\\&_\\.accordion-button\\]\\:capitalize .accordion-button {
  text-transform: capitalize;
}
.\\[\\&_\\.accordion-button\\]\\:leading-6 .accordion-button {
  line-height: 1.5rem;
}
.\\[\\&_\\.accordion-button\\]\\:text-white .accordion-button {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.\\[\\&_\\.accordion-button\\]\\:shadow-none .accordion-button {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\[\\&_\\.accordion-button\\]\\:focus\\:shadow-none:focus .accordion-button {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.\\[\\&_\\.accordion-icon\\]\\:absolute .accordion-icon {
  position: absolute;
}
.\\[\\&_\\.accordion-icon\\]\\:right-4 .accordion-icon {
  right: 1rem;
}
.\\[\\&_\\.accordion-icon_svg\\]\\:w-8 .accordion-icon svg {
  width: 2rem;
}
.\\[\\&_\\.accordion-item\\]\\:m-0 .accordion-item {
  margin: 0px;
}
.\\[\\&_\\.accordion-item\\]\\:border-0 .accordion-item {
  border-width: 0px;
}
.\\[\\&_\\.accordion-item\\]\\:bg-transparent .accordion-item {
  background-color: transparent;
}
.\\[\\&_\\.btn-secondary\\]\\:flex .btn-secondary {
  display: flex;
}
.\\[\\&_\\.btn-secondary\\]\\:min-h-8 .btn-secondary {
  min-height: 2rem;
}
.\\[\\&_\\.btn-secondary\\]\\:w-auto .btn-secondary {
  width: auto;
}
.\\[\\&_\\.btn-secondary\\]\\:items-center .btn-secondary {
  align-items: center;
}
.\\[\\&_\\.btn-secondary\\]\\:justify-center .btn-secondary {
  justify-content: center;
}
.\\[\\&_\\.btn-secondary\\]\\:rounded .btn-secondary {
  border-radius: 0.25rem;
}
.\\[\\&_\\.btn-secondary\\]\\:border .btn-secondary {
  border-width: 1px;
}
.\\[\\&_\\.btn-secondary\\]\\:border-\\[var\\(--footerBorder\\)\\] .btn-secondary {
  border-color: var(--footerBorder);
}
.\\[\\&_\\.btn-secondary\\]\\:bg-\\[var\\(--selectBg\\)\\] .btn-secondary {
  background-color: var(--selectBg);
}
.\\[\\&_\\.btn-secondary\\]\\:text-xs .btn-secondary {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\.btn-secondary\\]\\:font-normal .btn-secondary {
  font-weight: 400;
}
.\\[\\&_\\.btn-secondary\\]\\:text-\\[var\\(--gray-20\\)\\] .btn-secondary {
  color: var(--gray-20);
}
.\\[\\&_\\.btn-secondary_img\\]\\:mr-\\[0\\.313rem\\] .btn-secondary img {
  margin-right: 0.313rem;
}
.\\[\\&_\\.btn-secondary_img\\]\\:h-4 .btn-secondary img {
  height: 1rem;
}
.\\[\\&_\\.btn-secondary_img\\]\\:w-4 .btn-secondary img {
  width: 1rem;
}
.\\[\\&_\\.language-wrap\\]\\:flex .language-wrap {
  display: flex;
}
.\\[\\&_\\.language-wrap\\]\\:items-center .language-wrap {
  align-items: center;
}
.\\[\\&_\\.language-wrap\\]\\:justify-between .language-wrap {
  justify-content: space-between;
}
.\\[\\&_\\.language-wrap\\]\\:border-t .language-wrap {
  border-top-width: 1px;
}
.\\[\\&_\\.language-wrap\\]\\:border-\\[var\\(--gray-80\\)\\] .language-wrap {
  border-color: var(--gray-80);
}
.\\[\\&_\\.language-wrap\\]\\:pt-4 .language-wrap {
  padding-top: 1rem;
}
@media not all and (min-width: 640px) {
  .max-sm\\:\\[\\&_\\.language-wrap\\]\\:mb-8 .language-wrap {
    margin-bottom: 2rem;
  }
  .max-sm\\:\\[\\&_\\.language-wrap\\]\\:border-t-0 .language-wrap {
    border-top-width: 0px;
  }
  .max-sm\\:\\[\\&_\\.language-wrap\\]\\:pt-0 .language-wrap {
    padding-top: 0px;
  }
}
.\\[\\&_\\.language-wrap_p\\]\\:text-xs .language-wrap p {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_\\.language-wrap_p\\]\\:font-medium .language-wrap p {
  font-weight: 500;
}
.\\[\\&_\\.language-wrap_p\\]\\:leading-\\[1\\.063rem\\] .language-wrap p {
  line-height: 1.063rem;
}
.\\[\\&_\\.language-wrap_p\\]\\:text-\\[var\\(--gray-20\\)\\] .language-wrap p {
  color: var(--gray-20);
}
@media not all and (min-width: 640px) {
  .max-sm\\:\\[\\&_\\.language-wrap_p\\]\\:hidden .language-wrap p {
    display: none;
  }
}
.\\[\\&_\\.modal-content\\]\\:rounded-xl .modal-content {
  border-radius: 0.75rem;
}
@media not all and (min-width: 1024px) {
  .max-lg\\:\\[\\&_\\.modal-content\\]\\:rounded-none .modal-content {
    border-radius: 0px;
  }
  .max-lg\\:\\[\\&_\\.modal-content\\]\\:border-0 .modal-content {
    border-width: 0px;
  }
}
.\\[\\&_\\.modal-dialog\\]\\:fixed .modal-dialog {
  position: fixed;
}
.\\[\\&_\\.modal-dialog\\]\\:bottom-0 .modal-dialog {
  bottom: 0px;
}
.\\[\\&_\\.modal-dialog\\]\\:left-0 .modal-dialog {
  left: 0px;
}
.\\[\\&_\\.modal-dialog\\]\\:right-0 .modal-dialog {
  right: 0px;
}
.\\[\\&_\\.modal-dialog\\]\\:mb-0 .modal-dialog {
  margin-bottom: 0px;
}
.\\[\\&_\\.modal-dialog\\]\\:min-h-0 .modal-dialog {
  min-height: 0px;
}
.\\[\\&_\\.modal-dialog\\]\\:translate-y-0 .modal-dialog {
  --tw-translate-y: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media not all and (min-width: 768px) {
  .max-md\\:\\[\\&_\\.modal-dialog\\]\\:h-full .modal-dialog {
    height: 100%;
  }
}
@media (min-width: 768px) {
  .min-\\[768px\\]\\:\\[\\&_\\.modal-dialog\\]\\:min-w-\\[805px\\] .modal-dialog {
    min-width: 805px;
  }
}
.\\[\\&_a\\:hover\\]\\:text-gold a:hover {
  --tw-text-opacity: 1;
  color: rgb(239 212 60 / var(--tw-text-opacity, 1));
}
.\\[\\&_a\\]\\:mx-1 a {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.\\[\\&_a\\]\\:block a {
  display: block;
}
.\\[\\&_a\\]\\:px-\\[0\\.3rem\\] a {
  padding-left: 0.3rem;
  padding-right: 0.3rem;
}
.\\[\\&_a\\]\\:py-\\[0\\.313rem\\] a {
  padding-top: 0.313rem;
  padding-bottom: 0.313rem;
}
.\\[\\&_a\\]\\:pl-0\\.5 a {
  padding-left: 0.125rem;
}
.\\[\\&_a\\]\\:text-sm a {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.\\[\\&_a\\]\\:font-medium a {
  font-weight: 500;
}
.\\[\\&_a\\]\\:text-\\[var\\(--blue-300\\)\\] a {
  color: var(--blue-300);
}
.\\[\\&_a\\]\\:text-\\[var\\(--gray-20\\)\\] a {
  color: var(--gray-20);
}
.\\[\\&_a\\]\\:text-white a {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@media not all and (min-width: 1024px) {
  .max-lg\\:\\[\\&_button\\]\\:w-full button {
    width: 100%;
  }
}
.\\[\\&_canvas\\]\\:border-\\[5px\\] canvas {
  border-width: 5px;
}
.\\[\\&_canvas\\]\\:border-solid canvas {
  border-style: solid;
}
.\\[\\&_canvas\\]\\:border-white canvas {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity, 1));
}
.\\[\\&_h4\\]\\:m-0 h4 {
  margin: 0px;
}
.\\[\\&_h4\\]\\:pb-\\[0\\.2rem\\] h4 {
  padding-bottom: 0.2rem;
}
.\\[\\&_h4\\]\\:text-base h4 {
  font-size: 1rem;
  line-height: 1.5rem;
}
.\\[\\&_h4\\]\\:font-medium h4 {
  font-weight: 500;
}
.\\[\\&_h4\\]\\:uppercase h4 {
  text-transform: uppercase;
}
.\\[\\&_h4\\]\\:text-white h4 {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.\\[\\&_i\\]\\:text-\\[11px\\] i {
  font-size: 11px;
}
.\\[\\&_i\\]\\:leading-none i {
  line-height: 1;
}
.\\[\\&_img\\]\\:mb-0 img {
  margin-bottom: 0px;
}
.\\[\\&_img\\]\\:mr-0 img {
  margin-right: 0px;
}
.\\[\\&_img\\]\\:h-20 img {
  height: 5rem;
}
.\\[\\&_img\\]\\:h-\\[50px\\] img {
  height: 50px;
}
.\\[\\&_img\\]\\:h-auto img {
  height: auto;
}
.\\[\\&_img\\]\\:h-full img {
  height: 100%;
}
.\\[\\&_img\\]\\:max-h-\\[65px\\] img {
  max-height: 65px;
}
.\\[\\&_img\\]\\:w-20 img {
  width: 5rem;
}
.\\[\\&_img\\]\\:w-\\[100px\\] img {
  width: 100px;
}
.\\[\\&_img\\]\\:w-\\[34px\\] img {
  width: 34px;
}
.\\[\\&_img\\]\\:max-w-20 img {
  max-width: 5rem;
}
.\\[\\&_img\\]\\:max-w-full img {
  max-width: 100%;
}
.\\[\\&_img\\]\\:shrink-0 img {
  flex-shrink: 0;
}
.\\[\\&_img\\]\\:rounded-full img {
  border-radius: 9999px;
}
.\\[\\&_img\\]\\:object-cover img {
  object-fit: cover;
}
.\\[\\&_img\\]\\:object-center img {
  object-position: center;
}
@media not all and (min-width: 1024px) {
  .max-lg\\:\\[\\&_img\\]\\:mb-2 img {
    margin-bottom: 0.5rem;
  }
}
@media not all and (min-width: 640px) {
  .max-sm\\:\\[\\&_img\\]\\:h-8 img {
    height: 2rem;
  }
  .max-sm\\:\\[\\&_img\\]\\:w-8 img {
    width: 2rem;
  }
}
.\\[\\&_p\\:not\\(\\:last-child\\)\\]\\:before\\:absolute p:not(:last-child)::before {
  content: var(--tw-content);
  position: absolute;
}
.\\[\\&_p\\:not\\(\\:last-child\\)\\]\\:before\\:right-0 p:not(:last-child)::before {
  content: var(--tw-content);
  right: 0px;
}
.\\[\\&_p\\:not\\(\\:last-child\\)\\]\\:before\\:top-0 p:not(:last-child)::before {
  content: var(--tw-content);
  top: 0px;
}
.\\[\\&_p\\:not\\(\\:last-child\\)\\]\\:before\\:h-full p:not(:last-child)::before {
  content: var(--tw-content);
  height: 100%;
}
.\\[\\&_p\\:not\\(\\:last-child\\)\\]\\:before\\:w-px p:not(:last-child)::before {
  content: var(--tw-content);
  width: 1px;
}
.\\[\\&_p\\:not\\(\\:last-child\\)\\]\\:before\\:bg-white p:not(:last-child)::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.\\[\\&_p\\:not\\(\\:last-child\\)\\]\\:before\\:content-\\[\\\\\\'\\\\\\'\\] p:not(:last-child)::before {
  --tw-content: \\'\\';
  content: var(--tw-content);
}
.\\[\\&_p\\]\\:relative p {
  position: relative;
}
.\\[\\&_p\\]\\:m-0 p {
  margin: 0px;
}
.\\[\\&_p\\]\\:\\!mb-0 p {
  margin-bottom: 0px !important;
}
.\\[\\&_p\\]\\:px-2\\.5 p {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.\\[\\&_p\\]\\:text-xs p {
  font-size: 0.75rem;
  line-height: 1rem;
}
.\\[\\&_p\\]\\:font-medium p {
  font-weight: 500;
}
.\\[\\&_p\\]\\:font-semibold p {
  font-weight: 600;
}
.\\[\\&_p\\]\\:leading-5 p {
  line-height: 1.25rem;
}
.\\[\\&_p\\]\\:leading-\\[1\\.063rem\\] p {
  line-height: 1.063rem;
}
.\\[\\&_p\\]\\:text-\\[var\\(--gray-20\\)\\] p {
  color: var(--gray-20);
}
.\\[\\&_p\\]\\:text-white p {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
@media not all and (min-width: 768px) {
  .\\[\\&_p\\]\\:max-md\\:text-center p {
    text-align: center;
  }
  .max-md\\:\\[\\&_p\\]\\:text-\\[0\\.74rem\\] p {
    font-size: 0.74rem;
  }
}
.\\[\\&_svg\\]\\:mx-1 svg {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.\\[\\&_svg\\]\\:mx-auto svg {
  margin-left: auto;
  margin-right: auto;
}
.\\[\\&_svg\\]\\:mb-8 svg {
  margin-bottom: 2rem;
}
.\\[\\&_svg\\]\\:ml-\\[5px\\] svg {
  margin-left: 5px;
}
.\\[\\&_svg\\]\\:mr-1 svg {
  margin-right: 0.25rem;
}
.\\[\\&_svg\\]\\:mr-2 svg {
  margin-right: 0.5rem;
}
.\\[\\&_svg\\]\\:mr-2\\.5 svg {
  margin-right: 0.625rem;
}
.\\[\\&_svg\\]\\:mr-4 svg {
  margin-right: 1rem;
}
.\\[\\&_svg\\]\\:mt-2 svg {
  margin-top: 0.5rem;
}
.\\[\\&_svg\\]\\:block svg {
  display: block;
}
.\\[\\&_svg\\]\\:h-12 svg {
  height: 3rem;
}
.\\[\\&_svg\\]\\:h-2\\.5 svg {
  height: 0.625rem;
}
.\\[\\&_svg\\]\\:h-20 svg {
  height: 5rem;
}
.\\[\\&_svg\\]\\:h-3\\.5 svg {
  height: 0.875rem;
}
.\\[\\&_svg\\]\\:h-4 svg {
  height: 1rem;
}
.\\[\\&_svg\\]\\:h-5 svg {
  height: 1.25rem;
}
.\\[\\&_svg\\]\\:h-\\[13px\\] svg {
  height: 13px;
}
.\\[\\&_svg\\]\\:h-\\[14px\\] svg {
  height: 14px;
}
.\\[\\&_svg\\]\\:h-\\[68px\\] svg {
  height: 68px;
}
.\\[\\&_svg\\]\\:h-\\[97px\\] svg {
  height: 97px;
}
.\\[\\&_svg\\]\\:max-h-6 svg {
  max-height: 1.5rem;
}
.\\[\\&_svg\\]\\:w-2\\.5 svg {
  width: 0.625rem;
}
.\\[\\&_svg\\]\\:w-20 svg {
  width: 5rem;
}
.\\[\\&_svg\\]\\:w-3\\.5 svg {
  width: 0.875rem;
}
.\\[\\&_svg\\]\\:w-4 svg {
  width: 1rem;
}
.\\[\\&_svg\\]\\:w-5 svg {
  width: 1.25rem;
}
.\\[\\&_svg\\]\\:w-\\[13px\\] svg {
  width: 13px;
}
.\\[\\&_svg\\]\\:w-\\[14px\\] svg {
  width: 14px;
}
.\\[\\&_svg\\]\\:w-\\[238px\\] svg {
  width: 238px;
}
.\\[\\&_svg\\]\\:w-\\[68px\\] svg {
  width: 68px;
}
.\\[\\&_svg\\]\\:w-full svg {
  width: 100%;
}
.\\[\\&_svg\\]\\:max-w-20 svg {
  max-width: 5rem;
}
.\\[\\&_svg\\]\\:max-w-\\[2\\.875rem\\] svg {
  max-width: 2.875rem;
}
.\\[\\&_svg\\]\\:shrink-0 svg {
  flex-shrink: 0;
}
.\\[\\&_svg\\]\\:fill-current svg {
  fill: currentColor;
}
.\\[\\&_svg\\]\\:brightness-\\[10\\] svg {
  --tw-brightness: brightness(10);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
@media not all and (min-width: 1024px) {
  .max-lg\\:\\[\\&_svg\\]\\:mb-4 svg {
    margin-bottom: 1rem;
  }
  .max-lg\\:\\[\\&_svg\\]\\:h-14 svg {
    height: 3.5rem;
  }
  .max-lg\\:\\[\\&_svg\\]\\:w-14 svg {
    width: 3.5rem;
  }
  .max-lg\\:\\[\\&_svg\\]\\:max-w-14 svg {
    max-width: 3.5rem;
  }
}
@media not all and (min-width: 640px) {
  .max-sm\\:\\[\\&_svg\\]\\:mb-4 svg {
    margin-bottom: 1rem;
  }
  .max-sm\\:\\[\\&_svg\\]\\:mt-1 svg {
    margin-top: 0.25rem;
  }
  .max-sm\\:\\[\\&_svg\\]\\:h-4 svg {
    height: 1rem;
  }
  .max-sm\\:\\[\\&_svg\\]\\:h-9 svg {
    height: 2.25rem;
  }
  .max-sm\\:\\[\\&_svg\\]\\:w-4 svg {
    width: 1rem;
  }
  .max-sm\\:\\[\\&_svg\\]\\:w-\\[178px\\] svg {
    width: 178px;
  }
}
.prediction-market-page--casino .\\[\\.prediction-market-page--casino_\\&\\]\\:bg-\\[rgb\\(var\\(--pm-gold\\)\\)\\] {
  background-color: rgb(var(--pm-gold));
}
:is(body.prediction-market-open) .\\[\\:is\\(body\\.prediction-market-open\\)_\\&\\]\\:mt-0 {
  margin-top: 0px;
}
:is(body.prediction-market-open) .\\[\\:is\\(body\\.prediction-market-open\\)_\\&\\]\\:border-t-0 {
  border-top-width: 0px;
}
:is(body.prediction-market-open) .\\[\\:is\\(body\\.prediction-market-open\\)_\\&\\]\\:bg-\\[rgb\\(var\\(--pm-gold\\)\\)\\] {
  background-color: rgb(var(--pm-gold));
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,SAAA;EAAA;AAAA;AAAA;EAAA,QAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,mBAAA;IAAA;EAAA;EAAA;IAAA,qBAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,aAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA,UAAA;IAAA,aAAA;IAAA;EAAA;EAAA;IAAA,UAAA;IAAA,kBAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;IAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;UAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,uBAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA,uBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,0FAAA;EAAA,sFAAA;EAAA;AAAA;AAAA;EAAA,yFAAA;EAAA,qFAAA;EAAA;AAAA;AAAA;EAAA,gEAAA;EAAA,+DAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA;AAAA;AAAA;EAAA,gCAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA;AAAA;AAAA;EAAA,qBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA,gBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,6BAAA;EAAA;AAAA;AAAA;EAAA,iBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,eAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,mBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA,+BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,iCAAA;EAAA,yCAAA;EAAA;AAAA;AAAA;EAAA,uDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,0DAAA;EAAA,sFAAA;EAAA;AAAA;AAAA;EAAA,wDAAA;EAAA,sFAAA;EAAA;AAAA;AAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,+CAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,gFAAA;EAAA,iGAAA;EAAA;AAAA;AAAA;EAAA,mDAAA;EAAA,oDAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,yCAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,oDAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,sDAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,qDAAA;EAAA,sDAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,6FAAA;EAAA,6FAAA;EAAA;AAAA;AAAA;EAAA,mDAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,4FAAA;EAAA,4FAAA;EAAA;AAAA;AAAA;EAAA,2GAAA;EAAA,uIAAA;EAAA;AAAA;AAAA;EAAA,qDAAA;EAAA,yDAAA;EAAA;AAAA;AAAA;EAAA,wDAAA;EAAA,uDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,qDAAA;EAAA;AAAA;AAAA;EAAA,gDAAA;EAAA,6DAAA;EAAA;AAAA;AAAA;EAAA,+EAAA;EAAA,mGAAA;EAAA;AAAA;AAAA;EAAA,sBAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA,0BAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA,qCAAA;EAAA;AAAA;AAAA;EAAA,wJAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,oDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4DAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,kDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,qCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,qDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,sDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,2BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,2CAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,kCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,yBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,uCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,iDAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,sCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,qCAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,+FAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,4BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA,8BAAA;EAAA,wDAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAAA;EAAA;AAAA;AAGA;;EAEE,UAAA;EACA,SAAA;AADF;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,qBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,QAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,kBAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,kBAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,kDAKA;EALA,oDAKA;EALA;AAKA;AALA;EAAA,gBAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,SAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,eAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,eAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,gCAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,sBAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,sBAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,kBAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,8BAKA;EALA,wDAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,gBAKA;EALA;AAKA;AALA;EAAA,gBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,sBAKA;EALA,8BAKA;EALA;AAKA;AALA;EAAA,2BAKA;EALA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,uDAKA;EALA,wDAKA;EALA;AAKA;AALA;EAAA,oDAKA;EALA,sDAKA;EALA;AAKA;AALA;EAAA,2FAKA;EALA,4FAKA;EALA;AAKA;AALA;EAAA,4FAKA;EALA,6FAKA;EALA;AAKA;AALA;EAAA,sBAKA;EALA,8BAKA;EALA;AAKA;AALA;EAAA,gCAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,0BAKA;EALA,kBAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,kDAKA;EALA,oDAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,sBAKA;EALA,8BAKA;EALA;AAKA;AALA;EAAA,8BAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kDAKA;EALA,qDAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,qBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,eAKA;EALA,eAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA,kBAKA;IALA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,qDAKA;IALA,sDAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA,gBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,eAKA;IALA;EAKA;EALA;IAAA,kBAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;MAAA,UAKA;MALA;IAKA;IALA;MAAA,UAKA;MALA;IAKA;IALA;MAAA,UAKA;MALA;IAKA;IALA;MAAA,UAKA;MALA;IAKA;EAAA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,sBAKA;IALA;EAKA;EALA;IAAA,kBAKA;IALA;EAKA;EALA;IAAA,qBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,kBAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,kBAKA;IALA;EAKA;EALA;IAAA,oBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,oBAKA;IALA;EAKA;EALA;IAAA,qBAKA;IALA;EAKA;EALA;IAAA,oBAKA;IALA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA,kBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA,qBAKA;IALA;EAKA;EALA;IAAA,qBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA,qBAKA;IALA;EAKA;EALA;IAAA,oBAKA;IALA;EAKA;EALA;IAAA,qBAKA;IALA;EAKA;EALA;IAAA,iBAKA;IALA;EAKA;EALA;IAAA,gBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA,kBAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,iBAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA,iBAKA;IALA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,oBAKA;IALA;EAKA;EALA;IAAA,oBAKA;IALA;EAKA;EALA;IAAA,qBAKA;IALA;EAKA;EALA;IAAA,oBAKA;IALA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA,iBAKA;IALA;EAKA;EALA;IAAA,iBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,eAKA;IALA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA,kBAKA;IALA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,iBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA,eAKA;IALA;EAKA;EALA;IAAA,mBAKA;IALA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;MAAA;IAKA;EAAA;AAAA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oCAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,iBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,eAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;IAAA,mBAKA;IALA;EAKA;AAAA;AALA;EAAA;AAKA;AALA;EAAA,mBAKA;EALA;AAKA;AALA;EAAA,mBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,+BAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,iBAKA;EALA;AAKA;AALA;EAAA,iBAKA;EALA;AAKA;AALA;EAAA,eAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,sBAKA;EALA,8BAKA;EALA;AAKA;AALA;EAAA,sBAKA;EALA,8BAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA;AAKA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,qBAKA;EALA;AAKA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,qBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,mBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,eAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA;AAKA;AALA;EAAA,0BAKA;EALA,kBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,sBAKA;EALA;AAKA;AALA;EAAA,kBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA,oBAKA;EALA;AAKA;AALA;EAAA,iBAKA;EALA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA,+BAKA;EALA;AAKA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;EALA;IAAA;EAKA;AAAA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA;AALA;EAAA;AAKA","sourcesContent":["@tailwind utilities;\n\n\nhtml,\nbody {\n  padding: 0;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
